//#region Angular Imports

import { StateService } from '@uirouter/angularjs'

//#endregion

//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import CustomStore from 'devextreme/data/custom_store'
import DataSource from 'devextreme/data/data_source'
import ArrayStore from 'devextreme/data/array_store'
import dxQuery from 'devextreme/data/query'
import dxDataGrid, { dxDataGridColumn } from 'devextreme/ui/data_grid'

//#endregion

import { i18n } from '../i18n/common.i18n'

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { ColumnModel, GridModel, GridRequestReferenceModel, GridRequestModel } from '../../api/api.models'

import { ImportOptions } from '../import/import.directive'
import { ExportOptions, ExportController } from '../export/export.directive.controller'

import { Details } from '../common.details'
import { LoggerService } from '../common.module'
import { TableController, TableScope } from '../common.table.controller'

import { CommonHelper, Buttons } from '../../../helpers/common-helper'
import { ConfigHelper } from '../../../helpers/config-helper'
import { ConvertHelper } from '../../../helpers/convert-helper'
import { Dictionary } from '../../../helpers/dictionary'
import { EventsNames } from '../../../helpers/events-names'
import { PopupType } from '../../../helpers/popup-manager'
import { ReferenceTypeComponent } from '../../../helpers/reference-type-component'
import { TypeHelper } from '../../../helpers/type-helper'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { TemplateHelper } from '../../../helpers/template-helper'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { IUserSession } from '../../../helpers/user-session'
import { ToastHelper } from '../../../helpers/toast-helper'

//#region Model Imports

import { ColumnInfo } from '../../../models/custom/column-info'
import { Enums } from '../../../models/common/enums'
import { IOpObject } from '../../../models/util/interfaces'
import { KnownColor } from '../../../models/common/known-colors'
import { OpChangeState } from '../../../models/common/enums'
import { OpImportPlugin } from '../../../models/util/op-import-plugin'
import { OperatorLayoutSetting } from '../../../models/local/operator-layout-setting'
import { OpView } from '../../../models/core'
import { OpGridOption } from '../../../models/custom'

//#endregion

//#region Services Imports

import { DateBoxControlsService } from '../../../services/controls'
import { GridService } from '../../../services/grid'
import { DataTypeFormatService, DataTypeFormatter } from '../../../services/data-type'
import { DataExporter } from '../../../services/export'

//#endregion

import { GridItemAppearanceOptions, GridDataSourceType, GridCustomButtonsOptions, GridCustomButtonOptions, GridCustomButtonLocation, GridDataSourceParserDelegate } from './grid.interfaces'


export type Pagination = {
    columns: ColumnInfo[]
    pageNbr: number
    pageSize: number
    customWhereClause: string
}

export class GridTypes {
    static MAIN = 0
    static PAGINATED_SMALL = 1
    static SMALL = 2
    static CREATE_EDIT = 3
    static NO_SEARCH_BAR_SMALL = 4
    static NO_SEARCH_BAR_PAGINATED_SMALL = 5
    static NO_SEARCH_BAR_SMALL_SINGLE_PAGE = 6
}

export class GridPositions {
    static left = "OnTheLeft"
    static right = "OnTheRight"
    static top = "OnTheTop"
    static bottom = "OnTheBottom"
    static hide = "Hide"
}

export interface ButtonOptions {
    permissions?: string
    name: string
    options: DevExpress.ui.dxButtonOptions
}

export interface AdditionalFilter {
    columnName: string
    condition: string
}

export interface ButtonsOptions {
    enabled: boolean

    // events
    onAddClick?: (e) => void
    onCopyClick?: (e) => void
    onDeleteClick?: (e) => void
    onDepositryContentEdit?: (e) => void
    onEditClick?: (e) => void
    onGenerateReportClick?: (e) => void
    onGroupingLocationAssignLocations?: (e: any) => void
    onMultiselectClick?: () => void
    onOpenMassAssignedConfigurationProfile?(popupTitle: string, gridData: any, columns: any): void
    onPlanDeliveryClick?: () => void
    onProblemConfirmationClick?: () => void
    onShowClick?: (e) => void
    onShowFilters?: () => void
    onShowMap?: () => boolean
    onShowPreview?: () => boolean
    onToggleDetailsRows?(isExpanded: boolean): void

    // permissions
    addPermissions?: string
    alarmDefsMultiplePermissions?: string
    assigningToGroupPermisions?: string
    deletePermissions?: string,
    editPermissions?: string
    exportPermissions?: string
    generateReportPermissions?: string
    importPermissions?: string
    isRefreshButonHidden?: boolean
    issueMultiplePermissions?: string
    locationConfigurationMultiplePermissions?: string
    planDeliveryPermissions?: string
    problemConfirmationPermissions?: string
    saveColumnSettingsPermissions?: string
    showCopyButtonPermissions?: string
    showDetailsPermissions?: string
    taskMultiplePermissions?: string

    addTaskMultiple?: boolean
    addIssueMultiple?: boolean
    addLocationConfigurationMultiple?: boolean
    assigningToGroupMultiple?: boolean
    alarmDefsMultiple?: boolean
    copyOperator?: boolean
    problemConfirmation?: boolean
    planDelivery?: boolean

    //dashboard visibility
    dashboardSettings?: OpGridOption[]

    //for scripts results
    isSelectButtonHidden?: boolean

    //for depository
    depositoryContentEditPermission?: string

    groupingLocationAssignLocationsPermission?: string

    alarmDefsMultipleId?: number

    deleteRows?: boolean

    toggleDetailsRowsButtonVisible?: boolean

    copyButtonText?: string
}

export interface valueToCaption {
    value: any,
    caption: any
}

export interface columnValueToCaption {
    columnName: string
    values: valueToCaption[]
}

export interface GridOptions<TSource = any> {
    referenceId?: any
    type: number
    name: string
    needCustomFilter?: boolean
    exportMethod?: string
    localStorageVarForSavedEntity?: string
    dictionariesForSave?: any[]
    additionalTitle?: string
    idReferenceType?: number
    request?: (request?: GridRequestReferenceModel) => ng.IPromise<any>
    editing?: any
    selection?: any
    paging?: any
    pager?: any
    export?: any
    scrolling?: any
    columnFixing?: any
    height?: any
    addCustomFilters?: boolean
    showShortDetails?: boolean
    showColumnHeaders?: boolean
    showColumnLines?: boolean
    showRowLines?: boolean
    allowColumnReordering?: boolean
    filterRow?: any
    selectedRowKeys?: any
    onUpdateGridsterPosition?: (e) => void
    importOptions?: ImportOptions
    exportOptions?: ExportOptions
    columnAutoWidth?: boolean
    buttonsOptions: ButtonsOptions
    searchVisibleColumnsOnly?: boolean
    noDataText?: string

    /**
     * Method that returns patterns.
    */
    patternsProviderOptions?: {
        patternsProvider: () => JQueryPromise<any>,
        displayField: string
    }

    // columns
    defaultColumnsDictionary?: ColumnModel[]
    columnsDictionary?: ColumnModel[]
    columns?: DevExpress.ui.dxDataGridColumn[]

    // MasterDetail

    /**
     * DevExpress MasterDetail options.
     */
    masterDetail?: any

    /**
     * Function that should return true if the row that displays the given gridObject should also display details.
     *
     * TODO Po przerobieniu modułow zmienić aby ta funkcja zwracała obiekty biznesowe zamiast gridowych
     */
    masterDetailExists?: (data: any) => boolean

    /**
     * Indicates whether the auto-generated master detail column should be hidden when there is no items w/ details in the grid.
     * Defaults to true.
     * {@see GridOptions.masterDetailExists} should be defined and {@see GridOptions.masterDetail.enabled} set to use this option.
     */
    masterDetailColumnAutoHide?: boolean

    /**
     * Indicates whether the expand markers in the auto-generated master detail column should be hidden for items w/o details.
     * Defaults to true.
     * {@see GridOptions.masterDetailExists} should be defined and {@see GridOptions.masterDetail.enabled} set to use this option.
     */
    masterDetailExpandMarkerAutoHide?: boolean

    // MasterDetail End


    // Events

    onCellPrepared?(options): void
    onContentReady?(e): void
    onContextMenuPreparing?(e): void
    onDisposed?(): void
    onEditingStart?(e): void
    onEditorPreparing?(e): void
    onInitialized?(e: any, grid: GridController<any>): void
    onRowClick?(e): void
    onRowPrepared?(e): void
    onRowUpdated?(e): void
    onRowUpdating?(e): void
    onRowValidating?(e: any): void
    onSelectionChanged?(e): void
    onToolbarPreparing?(e): void

    // Events End


    // Custom Events

    onCellHoverChanged?: (e) => void

    /**
     * Called when data loading begins.
     */
    onDataLoad?(): void

    /**
     * Called when data arrives at the grid.
     */
    onDataReady?(data): void

    /**
     * Called when page changes.
     * Page index starts at 0.
     * Works only with remotely paginated data.
     */
    onPageChanged?(newPageIndex: number, oldPageIndex: number): void

    /**
     * Called when page size changes.
     * Works only with remotely paginated data.
     */
    onPageSizeChanged?(newPageSize: number, oldPageSize: number): void

    onRowDoubleClick?(e): void

    // Custom Events End


    contextMenuItems?: (boolean) => any

    additionalFilters?: AdditionalFilter[]

    preExecuteClearFilter?: boolean

    addColorToRows?: boolean
    addColorToCells?: boolean
    showDatatypeLegend?: boolean

    customValueToCaption?: columnValueToCaption[]

    ignoreKey?: boolean

    // Grid Items

    gridItemFilter?: (id: number) => boolean

    // Grid Items End


    //#region Buttons

    customButtonOptions?: GridCustomButtonsOptions

    //#endregion

    //#region Data Source

    /**
    * An array of data source objects or a promise that resolves with them.
    * 
    * TODO otypować
    */
    dataSource?: any

    dataSourceType?: GridDataSourceType

    /**
     * Whether to skip calling toJSON on the source object and attach it as a reference.
     */
    skipDataSourceSerialization?: boolean

    /**
     * Allows additional parsing of the data source objects before they are turned into grid objects and rendered onto the grid.
     */
    dataSourceParser?: GridDataSourceParserDelegate<TSource>

    // TODO DO USUNIĘCIA Po usunięciu z wszystkich gridów
    dataSourceAdditionalFields?: { name: string, map: <T>(obj: T) => any }[]

    /**
     * A function that should return an array of data source objects or a promise that resolves with them.
     */
    getDataSource?: (() => any[]) | (() => JQueryPromise<any[]>)

    /**
     * A function that returns a key that idetifies the source object.
     */
    getDataSourceKey?: (sourceObject: TSource) => any

    /**
     * A function that returns a key that idetifies the parent source object.
     */
    getParentDataSourceKey?: (parentSourceObject: any) => any

    /**
     * Data source filtering method from the web service. 
     * 
     * TODO zmienić na getDataSourceFilter?
     */
    getDataSourceMethod?: (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => JQueryPromise<{ objects: IOpObject[], totalCount: number, error: { code: any, msg: string } }>

    //#endregion

    hideHeaderCheckbox?: boolean
    skipDeselectingOnPageChange?: boolean
    dragging?: DevExpress.ui.GridBaseOptions['rowDragging']
}

interface GridScope extends TableScope<DevExpress.ui.dxDataGridOptions> {

    // directive options
    options: GridOptions

    headerButtons: any
    customHeaderButtons: any
    isLegendShown: boolean
    legendData: any
}

export class GridController<TSource> extends TableController<DevExpress.ui.dxDataGrid, DevExpress.ui.dxDataGridOptions>{

    //#region Consts

    private get GRID_ID_FIELD_NAME(): string { return 'id' }
    private get GRID_NAME_FIELD_NAME(): string { return 'name' }
    private get GRID_PARENT_OBJECT_ID_FIELD_NAME(): string { return '__PARENT_ID__' }

    private get ROW_ADDED_CLASS(): string { return 'grid__row_added' }
    private get ROW_REMOVED_CLASS(): string { return 'grid__row_removed' }
    private get ROW_MODIFIED_CLASS(): string { return 'grid__row_modified' }
    private get ROW_CORRECT_CLASS(): string { return 'grid__row_correct' }
    private get ROW_INCORRECT_CLASS(): string { return 'grid__row_incorrect' }
    private get ROW_WARNING_CLASS(): string { return 'grid__row_warning' }

    private get DEFAULT_DETAILS_COLUMN_AUTO_HIDE_VALUE(): boolean { return true }
    private get DEFAULT_DETAILS_EXPAND_MARKER_AUTO_HIDE_VALUE(): boolean { return true }
    private get DEFAULT_DATA_SOURCE_PROPERTIES_SOURCE_VALUE(): GridDataSourceType { return GridDataSourceType.Auto }

    //#endregion


    // Localization Consts

    private get LOCALIZATION_COLLECTION_NAME() { return 'Grid' }

    private localizationText = class {
        public static get NoAvailablePlugins() { return 'NoAvailablePlugins' }
        public static get Import() { return 'Import' }
    }

    private getLocalizedText(text: string): string {
        return LocalizationHelper.getLocalizedText(text, { collection: this.LOCALIZATION_COLLECTION_NAME })
    }

    // Localization Consts End


    // Members

    private exporter: ExportController;

    private _prependedItems: TSource[] = []

    /**
     * Used when there is no reference type option specified. Its value is set from the first object in the data source.
     */
    private sourceObjectConstructor: new (...args: any[]) => any

    private displayStateDict: Dictionary<GridItemAppearanceOptions> = new Dictionary<GridItemAppearanceOptions>(null)

    private lastSelectedIds: number[]

    private lastPageIndex: number = -1

    private lastPageSize: number = -1

    // Members End


    // Options Members

    private remoteOperations: any

    private isLocalDataSource: boolean = false

    private allowedPageSizes: number[]
    private defaultPageSize: number

    // Options Members End

    //#region Properties

    public get dxGrid(): DevExpress.ui.dxDataGrid {
        return this.table
    }

    public get items(): TSource[] {
        return _.map(this.dxGrid.getDataSource().items(), (gridItem: any) => {
            return this.getSourceObject(gridItem)
        })
    }

    public get prependedItems(): TSource[] {
        return this._prependedItems
    }

    public get pageItemsIds(): number[] {
        return this.dxGrid
            .getVisibleRows()
            .map((row: DevExpress.ui.dxDataGridRowObject) => this.getSourceObjectId(row.data))
    }

    public get pageItems(): TSource[] {
        return this.dxGrid
            .getVisibleRows()
            .map((row: DevExpress.ui.dxDataGridRowObject) => this.getSourceObject(row.data))
    }

    public get selectedCount(): number {
        return this.dxGrid.getSelectedRowKeys().length
    }

    public get selectedItemId(): number {
        return this.getSourceObjectId(this.dxGrid.getSelectedRowsData()[0])
    }

    public get selectedItemsIds(): number[] {
        const selectedItems: any[] | JQueryPromise<any[]> = this.dxGrid.getSelectedRowsData()

        if (!TypeHelper.isPromise(selectedItems)) {
            return (selectedItems).map((gridObject: any) => this.getSourceObjectId(gridObject))
        }

        return [];
    }

    public get selectedItemsIdsAsync(): JQueryPromise<number[]> {
        const selectedItems: any[] | JQueryPromise<any[]> = this.dxGrid.getSelectedRowsData()

        if (TypeHelper.isPromise(selectedItems)) {
            return selectedItems.then((items: any[]) => {
                return items.map((gridObject: any) => this.getSourceObjectId(gridObject));
            })
        }

        return $.Deferred().resolve([]).promise();
    }

    public get selectedItem(): TSource {
        return this.getSourceObject(this.dxGrid.getSelectedRowsData()[0])
    }

    public get selectedItems(): TSource[] {
        return this.dxGrid
            .getSelectedRowsData()
            .map((gridObject: any) => this.getSourceObject(gridObject))
    }

    public get selectedGridItems(): any[] {
        return this.dxGrid.getSelectedRowsData()
    }

    //#endregion

    //#region Ctor

    public constructor(
        protected readonly $scope: GridScope,
        protected readonly $timeout: ng.ITimeoutService,
        protected readonly $state: StateService,
        protected readonly logger: LoggerService,
        protected readonly $q: ng.IQService,
        protected readonly localDictionary: LocalDictionaryFactory,
        protected readonly api: Api,
        protected readonly $compile: ng.ICompileService,
        protected readonly userSession: IUserSession,
        protected readonly dataTypeFormatService: DataTypeFormatService,
        protected readonly dateBoxControlsService: DateBoxControlsService
    ) {
        super($scope.options, $scope, $timeout, $state, logger, $q, localDictionary, api, $compile, userSession, dataTypeFormatService, dateBoxControlsService)

        $scope.$on('$destroy', () => {
            if ($scope.options.onDisposed != null) {
                $scope.options.onDisposed()
            }
        })

        if ($scope.options.showDatatypeLegend) {
            $scope.isLegendShown = $scope.options.name != null ? OperatorLayoutSettings.getSetting('IS_SHOWN_GRID_DATATYPE_LEGEND_' + $scope.options.name, false) : false
            // TODO: trzeba zrobi� dynamiczna legend�, �P: nie wie jeszcze jak
            $scope.legendData = {
                rects: [
                    { color: '##ffc0cb', description: 'Sent, not confirmed' },
                    { color: '#f0e68c', description: 'Not sent' }
                ]
            }
        }

        dxDataGrid.defaultOptions({
            options: {
                noDataText: ''
            }
        })

        if ($scope.options.name != null) {
            if (OperatorLayoutSettings.getSetting('LAST_SET_COLUMN_SETTINGS_' + $scope.options.name, null) === null) {
                OperatorLayoutSettings.setSetting('LAST_SET_COLUMN_SETTINGS_' + $scope.options.name, 'default');
            }

            if (this.$scope.options.preExecuteClearFilter != true) {
                this.filteredColumnName = OperatorLayoutSettings.getSetting(CommonHelper.FILTERED_COLUMN + '_' + $scope.options.name, null)
                $scope.filterText = OperatorLayoutSettings.getSetting(CommonHelper.FILTER_TEXT + '_' + $scope.options.name, null)
                var filterLabel = OperatorLayoutSettings.getSetting(CommonHelper.FILTER_LABEL + '_' + $scope.options.name, null)
                if (filterLabel) {
                    this.$scope.filterTextLabel = filterLabel
                } else {
                    this.$scope.filterTextLabel = i18n('Popup', 'NoColumnSelected')
                }
                this.lastSelectedFilterColumnIndex = OperatorLayoutSettings.getSetting(CommonHelper.LAST_SELECTED_ROW + '_' + $scope.options.name, null)
            }
            else {
                var localStarageGridData = OperatorLayoutSettings.getSetting('SAVED_TABLE_' + $scope.options.name, null)
                if (localStarageGridData) {
                    angular.forEach(localStarageGridData.columns, (obj, key) => {
                        if (obj.filterValue) {
                            obj.filterValue = undefined
                        }
                    })
                    OperatorLayoutSettings.setSetting('SAVED_TABLE_' + $scope.options.name, localStarageGridData)
                }
            }
        }

        this.setCustomFilterButtonsState()
        $scope['noDataText'] = this.$scope.options.noDataText

        $
            .when<any>(
                this.getActiveView(),
                this.getDataTypeFormatter(),
            )
            .then((view: OpView, dataTypeFormatter: DataTypeFormatter) => {
                this.dataTypeFormatter = dataTypeFormatter

                if (view != null) {
                    this.view = view
                    this.primaryColumn = view.getPrimaryKeyColumn()
                }
            })
            .always(() => {
                this.getPageItems()
                    .always(() => {
                        $scope.tableOptions = this.getDataGridOptions()

                        $scope.filterBoxOptions = <any>{
                            readOnly: false,
                            multiline: false,
                            displayExpr: 'filter',
                            onInitialized: (e) => {
                                this.filterBox = e.component
                            },
                            onValueChanged: (e) => {
                                this.tagBoxSelectionChanged(e.value, e.previousValue, e)
                            },
                            showClearButton: false,
                            placeholder: i18n("Grid", "NoActiveFilters"),
                            disabled: false,
                            opened: false,
                            showSelectionControls: false
                        }

                        // header buttons
                        this.buttons = this.getButtons()
                        $scope.headerButtons = {}
                        $scope.customHeaderButtons = {}
                        this.buttons.forEach(button => {
                            $scope.headerButtons[button.name + $scope.tableId] = button.options
                        })

                        if (this.$scope.options.customButtonOptions != null) {
                            this.customButtons = this.$scope.options.customButtonOptions.buttons

                            _.forEach(this.$scope.options.customButtonOptions.buttons, (buttonOptions: GridCustomButtonOptions, index: number) => {
                                $scope.customHeaderButtons[index.toString() + $scope.tableId.toString()] = buttonOptions.options
                            })
                        }

                        if (this.customButtons == null) {
                            this.customButtons = []
                        }

                        // ---

                        if (this.$scope.options.localStorageVarForSavedEntity) {
                            this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => {
                                var isSaved = CommonHelper.getValueFromLocalStorage(this.$scope.options.localStorageVarForSavedEntity)
                                if (isSaved) {
                                    if (this.$scope.options.dictionariesForSave) {
                                        var items = []
                                        Details.filterFields(args[0].detailsFields, this.$scope.options.dictionariesForSave).forEach((field) => {
                                            items.push({
                                                description: field.caption,
                                                index: field.index,
                                                value: field.value,
                                                typeId: field.typeId
                                            })
                                        })

                                        this.table.option('dataSource', new DataSource(items))
                                    } else {
                                        this.lastSelectedIds = this.table.getSelectedRowKeys()
                                        this.table.refresh()
                                    }
                                    CommonHelper.removeValueFromLocalStorage(this.$scope.options.localStorageVarForSavedEntity)
                                }
                            })

                            this.$scope.$on(EventsNames.CLOSED_IMPORT_POPUP, (event, ...args) => {
                                this.table.refresh()
                            })
                        }

                        $scope.showPageSizeSelectorText = false

                        $scope.$on(EventsNames.REFRESH_GRID_SIZE, _.debounce(() => {
                            if (this.table) {
                                this.table.updateDimensions()
                            }
                        }, 500))

                        super.callBaseClassConstructor()
                    })
                    .fail((error: any) => {
                        console.info(this.LOG_STRING, error)
                    })
            })
    }
    //#endregion

    //#region Columns

    public setColumnsDictionary(columns: ColumnModel[]): void {
        const dxColumns: DevExpress.ui.dxDataGridColumn[] = this.getDxColumns(columns)

        if (this.dxGrid != null) {
            this.options.columnsDictionary = columns
            this.dxGrid.option('columns', dxColumns)
        }
    }


    //#endregion

    //#region Data Source

    public containsItem(sourceItem: TSource): boolean {
        return _.find(this.items, (item: TSource) => {
            return this.sourceItemsEquals(sourceItem, item)
        }) != null
    }

    public refresh(): void {
        if (this.dxGrid != null) {
            this.dxGrid.refresh()
        }
    }

    /**
     * Sets a new data source that is not refreshable and is filtered locally.
     * 
     * @param data - An array of data or a promise that resolves with the data.
     */
    public setDataSource(data: any[] | JQueryPromise<any[]>): void {
        if (data == null) {
            throw new Error("The given data cannot be undefined.")
        }

        const deferred: JQueryDeferred<any[]> = $.Deferred<any[]>()

        if (TypeHelper.isPromise(data)) {
            data.then(deferred.resolve)
                .fail(deferred.reject)
        } else {
            deferred.resolve(data)
        }

        const dataSource: DataSource = new DataSource(new CustomStore({
            load: (options: DevExpress.data.LoadOptions) => {
                if (this.$scope.options.onDataLoad) {
                    this.$scope.options.onDataLoad()
                }

                return this.handleDataSourcePromise(deferred.promise());
            },

            update: () => {
                return $.Deferred().resolve().promise()
            },
        }))

        if (this.dataSource == null) {
            this.isLocalDataSource = true
            this.isFilteredLocally = true
            this.dataSource = dataSource
            this.remoteOperations = false
        } else {
            this.dxGrid.option('remoteOperations', false)

            this.dxGrid.option('dataSource').dispose()
            this.dxGrid.option('dataSource', dataSource)
        }
    }

    public setGetDataSourceMethod(method: (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => any) {
        this.$scope.options.getDataSourceMethod = method
    }

    /**
     * Sets a function that will be used to get the new data source. The data source is refreshable and is filtered locally.
     * 
     * @param getData - A function that returns an array of data or a promise that resolves with the data.
     */
    public setGetDataSource(getData: () => (any[] | JQueryPromise<any[]>)): void {
        if (getData == null) {
            throw new Error("The given getData function cannot be undefined.")
        }

        const dataSource: DataSource = new DataSource(new CustomStore({
            load: (options: DevExpress.data.LoadOptions) => {
                if (this.$scope.options.onDataLoad) {
                    this.$scope.options.onDataLoad();
                }

                const deferred: JQueryDeferred<any[]> = $.Deferred<any[]>()
                const getDataResult: any = getData();

                if (TypeHelper.isPromise(getDataResult)) {
                    getDataResult
                        .then(deferred.resolve)
                        .fail(deferred.reject);
                } else {
                    deferred.resolve(getDataResult);
                }

                return this.handleDataSourcePromise(deferred.promise());
            },

            update: () => {
                return $.Deferred().resolve().promise()
            },
        }))

        if (this.dataSource == null) {
            this.dataSource = dataSource;
            this.isFilteredLocally = true
            this.remoteOperations = false;
        } else {
            this.dxGrid.option('remoteOperations', false);

            this.dxGrid.option('dataSource').dispose();
            this.dxGrid.option('dataSource', dataSource);
        }
    }

    private handleDataSourcePromise(promise: JQueryPromise<TSource[]>) {
        return promise
            .then((result: TSource[]) => {
                if (result == null) {
                    console.warn(this.LOG_STRING, 'The received data is null or undefined.');

                    return [];
                }

                if (this.$scope.options.onDataReady) {
                    this.$scope.options.onDataReady(result);
                }

                return this.prepareGridObjects(result, this.$scope.options.columnsDictionary);
            })
            .fail((error: any) => {
                console.warn(this.LOG_STRING, 'There was an error while getting data.');

                return [];
            });
    }

    private sourceItemsEquals(sourceItem1: TSource, sourceItem2: TSource): boolean {
        return this.getDataSourceId(sourceItem1) === this.getDataSourceId(sourceItem2)
    }

    private getDataSourceId(sourceItem: TSource): any {
        if (_.isFunction(this.$scope.options.getDataSourceKey)) {
            return this.$scope.options.getDataSourceKey(sourceItem)
        }

        return TypeHelper.getId(sourceItem)
    }

    private getParentDataSourceId(dataSource: TSource): any {
        if (_.isFunction(this.$scope.options.getParentDataSourceKey)) {
            return this.$scope.options.getParentDataSourceKey(dataSource)
        }

        return TypeHelper.getId(dataSource)
    }

    private getFilteredAndSortedData(): JQueryPromise<any[]> {
        return this.dxGrid
            .getDataSource()
            .store()
            .load()
            .then((result: any) => {
                const loadOptions: any = this.dxGrid.getDataSource().loadOptions()
                const combindeFilter: any = this.dxGrid.getCombinedFilter()
                let query: DevExpress.data.Query = dxQuery(result)

                if (combindeFilter != null) {
                    query = query.filter(combindeFilter)
                }

                if (loadOptions.sort != null) {
                    let sorted: boolean = false

                    _.forEach(loadOptions.sort, (sortCriteria: any) => {
                        if (sorted) {
                            query = query.thenBy(sortCriteria.selector, sortCriteria.desc)
                        } else {
                            query = query.sortBy(sortCriteria.selector, sortCriteria.desc)
                            sorted = true
                        }
                    })
                }

                return query.toArray()
            })
    }

    //#endregion

    //#region Export

    private export(): void {
        if (this.exporter != null) {
            if (this.$scope.options.exportOptions.exportDataMethod) {
                this.exportVisibleData()
            }
            else {
                this.exportFilter()
            }
        }
    }

    private exportVisibleData(): void {
        this.getFilteredAndSortedData()
            .then((data: any[]) => {
                const dataExporter: DataExporter = this.exporter.getDataExporter()

                _
                    .chain(this.dxGrid.option('columns'))
                    .filter((column: dxDataGridColumn) => {
                        return column.visible
                    })
                    .forEach((visibleColumn: dxDataGridColumn, columnIndex: number) => {
                        const columnDataField: string = visibleColumn.dataField

                        // idDataTypeFormat is set in Table in dashboard
                        const idDataTypeFormat: Enums.DataTypeClass = (visibleColumn as any).idDataTypeFormat;

                        dataExporter.addColumn(visibleColumn.caption, idDataTypeFormat)

                        _.forEach(data, (dataRow: any, rowIndex: number) => {
                            let data: any = dataRow[columnDataField]

                            if (_.isFunction(this.$scope.options.exportOptions.formatValue)) {
                                data = this.$scope.options.exportOptions.formatValue({
                                    value: dataRow[columnDataField],
                                    columnName: columnDataField
                                })
                            }

                            dataExporter.addRowData(columnIndex, rowIndex, data)
                        })
                    })

                this.exporter.exportData(dataExporter)
            })
    }

    private exportFilter(): void {
        const requestModel: GridRequestReferenceModel = this.getRequest(1, 1, true)
        const columns: ColumnInfo[] = CommonHelper.convertToColumnInfo(requestModel.columns)

        this.exporter.exportFilter(columns, requestModel.where)
    }

    //#endregion

    //#region Pagination

    public getPagination(): Pagination {
        const request: GridRequestReferenceModel = this.getRequest()

        return {
            columns: _.size(request.columns) ? request.columns.map((c: ColumnModel) => new ColumnInfo(c)) : [],
            pageNbr: request.pageNumber,
            pageSize: request.pageSize,
            customWhereClause: request.where
        }
    }

    //#endregion

    //#region Item Prepending

    /**
     * Prepends an item into the top of the grid. Doesn't modify the original data source.
     *
     * @param item - A grid item to prepend.
     * @param opState - OpChangeState indicating the style of the item.
     */
    public prependItem(item: TSource, opState: OpChangeState = null): void {
        if (item == null) {
            throw new Error("Trying to prepend an undefined object into the grid.")
        }

        this.prependedItems.unshift(item)

        if (opState != null) {
            this.setItemDisplayState(item, { opState })
        }
    }

    public replacePrependedItem(originalItem: TSource, newItem: TSource): void {
        if (originalItem != null && newItem != null && this.getDataSourceId(originalItem) === this.getDataSourceId(newItem)) {
            const itemIndex: number = _.findIndex(this.prependedItems, (prependedItem: TSource) => this.getDataSourceId(prependedItem) === this.getDataSourceId(originalItem))

            if (itemIndex > -1) {
                this.prependedItems[itemIndex] = newItem
            }
        }
    }

    /**
     * Removes a prepended item from the grid.
     * 
     * @param item - A prepended grid object to remove.
     */
    public removePrependedItem(item: TSource): void {
        if (item == null) {
            throw new Error("Trying to remove an undefined object from the grid.")
        }

        const itemIndex: number = _.findIndex(this.prependedItems, (prependedItem: TSource) => this.getDataSourceId(prependedItem) === this.getDataSourceId(item))

        if (itemIndex > -1) {
            this.prependedItems.splice(itemIndex, 1)
            this.removeItemDisplayState(item)
        }
    }

    /**
     * Clears the list of prepended items.
     */
    public clearPrependedItems(): void {
        this._prependedItems = []
        this.clearItemDisplayStates()
    }

    //#endregion

    //#region Item Appearence

    /**
     * Sets a style of an item inside the grid.
     *
     * @param item - An object to style.
     * @param opState - OpChangeState indicating the style of the object.
     */

    public setItemDisplayState(item: TSource, options: OpChangeState): void
    public setItemDisplayState(item: TSource, options: GridItemAppearanceOptions): void
    public setItemDisplayState(item: TSource, options: OpChangeState | GridItemAppearanceOptions): void {
        if (item == null) {
            throw new Error("Trying to set item display state for an undefined object.")
        }

        let displayOptions: GridItemAppearanceOptions = null

        if (!_.isObject(options)) {
            displayOptions = { opState: options as OpChangeState }
        } else {
            displayOptions = options as GridItemAppearanceOptions
        }

        this.displayStateDict.add(this.getDataSourceId(item), displayOptions)

        const itemIdx: number = _.findIndex(this.pageItems, (pageItem: TSource) => this.getDataSourceId(pageItem) === this.getDataSourceId(item))

        if (itemIdx > -1) {
            this.dxGrid.repaintRows([itemIdx])
        }
    }

    /**
     * Removes a style from an item.
     * 
     * @param item - A prepended object to remove.
     */
    public removeItemDisplayState(item: TSource): void {
        if (item == null) {
            throw new Error("Trying to remove item display state for an undefined object.")
        }

        this.displayStateDict.remove(this.getDataSourceId(item))

        const itemIdx: number = _.findIndex(this.pageItems, (pageItem: TSource) => this.getDataSourceId(pageItem) === this.getDataSourceId(item))

        if (itemIdx > -1) {
            this.dxGrid.repaintRows([itemIdx])
        }
    }

    /**
     * Clears the styles of items.
     */
    public clearItemDisplayStates(): void {
        this.displayStateDict = new Dictionary<any>(null)
        this.dxGrid.repaint()
    }

    //#endregion

    //#region Item Selection

    public scrollToSelected(): void {
        const scrollable: any = (this.dxGrid as any).getView('rowsView')._scrollable
        const selectedRowElements = (this.dxGrid as any).element().find('tr.dx-selection')
        const gridHeight = (this.dxGrid as any).getView('gridView')._rootElement[0].clientHeight

        if (selectedRowElements != null && selectedRowElements.length > 0 && selectedRowElements[0] != null && scrollable != null) {
            scrollable.scrollTo({
                left: 0,
                top: selectedRowElements[0].offsetTop - (gridHeight / 4),
            })
        }
    }

    public select(sourceObjects: TSource[]): void {
        const sourceObjectsIds: number[] = _.map(sourceObjects, (object: TSource) => this.getSourceObjectId(object))

        this.selectById(sourceObjectsIds)
    }

    public selectById(id: number | number[]): void {
        const ids: number[] = _.isArray(id) ? id : [id]

        this.getFilteredAndSortedData()
            .then((filteredResult: any[]) => {


                let filteredIndex: number = -1

                _.forEach(filteredResult, (filteredItem: any, index: number) => {
                    if (_.include(ids, filteredItem.id)) {
                        filteredIndex = index
                    }
                })

                this.selectItemByIndex(filteredIndex)
            })
    }

    /**
     * Deselects items that are not on the current page.
     */
    private deselectNonPageItems(): void {
        const selectedIds = this.selectedItemsIds
        const nonPageItemsIds = _.difference(selectedIds, this.pageItemsIds)

        if (selectedIds.length - nonPageItemsIds.length === 0) {
            this.$scope.nothingSelected = true
        }

        if (!this.$scope.options.skipDeselectingOnPageChange && nonPageItemsIds.length > 0) {
            this.dxGrid.deselectRows(nonPageItemsIds)
        }
    }

    /**
     * Selects an item at the given index. Switches pages if necessary.
     */
    private selectItemByIndex(index: number): void {
        const pageSize: number = this.dxGrid.pageSize()
        const pageIndex: number = Math.floor(index / pageSize)
        const itemIndex: number = index - pageSize * pageIndex;

        // pageIndex(index) returns void if index is on the current page, promise otherwise.
        const pageChangeResult: void | JQueryPromise<void> = this.dxGrid.pageIndex(pageIndex) as void | JQueryPromise<void>

        if (TypeHelper.isPromise(pageChangeResult)) {
            (pageChangeResult as JQueryPromise<void>).then(() => {
                this.dxGrid.selectRowsByIndexes([itemIndex])
            })
        } else {
            this.dxGrid.selectRowsByIndexes([itemIndex])
        }
    }

    //#endregion

    //#region MasterDetail

    /**
     * Removes the icon from the auto-generated master detail column for items that the {@see GridOptions.masterDetailExists} function returned false.
     *
     * @param e - Dx onCellPrepared event object.
     */
    private toggleMasterDetailArrow(e: any): void {
        const masterDetailExpandMarkerAutoHide: boolean = this.$scope.options.masterDetailExpandMarkerAutoHide == null
            ? this.DEFAULT_DETAILS_EXPAND_MARKER_AUTO_HIDE_VALUE
            : this.$scope.options.masterDetailExpandMarkerAutoHide

        if (masterDetailExpandMarkerAutoHide
            && e.rowType === 'data'
            && e.column.command === "expand"
            && !this.$scope.options.masterDetailExists(e.data)) {

            e.cellElement.removeClass("dx-datagrid-expand")
            e.cellElement.empty()
        }
    }

    /**
     * Removes the auto-generated master detail column if items in the grid do not contain any details.
     *
     * @param e - Dx onContentReady event object.
     */
    private toggleMasterDetailColumn(e: any): void {
        if (this.$scope.options.masterDetail && this.$scope.options.masterDetail.enabled && this.$scope.options.masterDetailExists) {
            const masterDetailColumnAutoHide: boolean = this.$scope.options.masterDetailColumnAutoHide == null
                ? this.DEFAULT_DETAILS_COLUMN_AUTO_HIDE_VALUE
                : this.$scope.options.masterDetailColumnAutoHide

            if (masterDetailColumnAutoHide) {
                const pageGridObjects = this.dxGrid.getVisibleRows().map((row: DevExpress.ui.dxDataGridRowObject) => row.data)
                const detailsExist = pageGridObjects.some((gridObject: any) => this.$scope.options.masterDetailExists(gridObject))

                this.dxGrid.option('masterDetail.enabled', detailsExist)
            }
        }
    }

    //#endregion

    //#region Setup

    private setupEvents(e: any): void {
        e.component.on({
            'rowPrepared': (e: any) => this.onRowPrepared(e),
            'cellPrepared': (e: any) => this.onCellPrepared(e),
            'editorPreparing': (e: any) => this.onEditorPreparing(e)
        })
    }

    //#endregion

    //#region Events

    private onCellPrepared(e: any): void {
        if (this.$scope.options.onCellPrepared) {
            this.$scope.options.onCellPrepared(e)
        }

        if (this.$scope.options.masterDetail && this.$scope.options.masterDetail.enabled && this.$scope.options.masterDetailExists) {
            this.toggleMasterDetailArrow(e)
        }
    }

    private onEditorPreparing(e: any): void {
        if (this.$scope.options.onEditorPreparing) {
            this.$scope.options.onEditorPreparing(e)
        }

        this.setRestoreEditorFocus(e)
    }

    private onRowPrepared(e: any): void {
        if (e.rowType == 'data') {
            const displayStateOptions: GridItemAppearanceOptions = this.displayStateDict.tryGetValue(this.getSourceObjectId(e.data))

            if (displayStateOptions != null) {
                switch (displayStateOptions.opState) {
                    case OpChangeState.Delete:
                        $(e.rowElement).addClass(this.ROW_REMOVED_CLASS)
                        break
                    case OpChangeState.New:
                        $(e.rowElement).addClass(this.ROW_ADDED_CLASS)
                        break
                    case OpChangeState.Modified:
                        $(e.rowElement).addClass(this.ROW_MODIFIED_CLASS)
                        break
                }

                switch (displayStateOptions.validation) {
                    case Enums.ValidationStatus.Correct:
                        $(e.rowElement).addClass(this.ROW_CORRECT_CLASS)
                        break

                    case Enums.ValidationStatus.Incorrect:
                        $(e.rowElement).addClass(this.ROW_INCORRECT_CLASS)
                        break

                    case Enums.ValidationStatus.Warning:
                        $(e.rowElement).addClass(this.ROW_WARNING_CLASS)
                        break
                }
            }
        }
    }

    //#endregion

    //#region Custom Events

    private onPageChanged(e: any): void {
        const newPageIndex: number = e.component.pageIndex()

        if (this.lastPageIndex !== newPageIndex) {
            if (this.lastPageIndex !== -1) {
                if (this.$scope.options.onPageChanged) {
                    this.$scope.options.onPageChanged(newPageIndex, this.lastPageIndex)
                }

                this.deselectNonPageItems()
            }

            this.lastPageIndex = newPageIndex
        }
    }

    private onPageSizeChanged(e: any): void {
        const newPageSize: number = e.component.pageSize()

        if (this.lastPageSize !== newPageSize) {
            if (this.lastPageSize !== -1) {
                if (this.$scope.options.onPageSizeChanged) {
                    this.$scope.options.onPageSizeChanged(newPageSize, this.lastPageSize)
                }

                this.deselectNonPageItems()
            }

            this.lastPageSize = newPageSize
        }
    }

    //#endregion


    private getButtons() {
        var buttons: ButtonOptions[] = []

        if (this.$scope.options.buttonsOptions.addLocationConfigurationMultiple && this.$scope.options.buttonsOptions.locationConfigurationMultiplePermissions) {
            buttons.push({
                name: 'locationConfigurationMultipleButton',
                options: {
                    onClick: () => {
                        let columnCount: number = this.table.columnCount()
                        let columns: any = []

                        for (let i = 0; i < columnCount; i++) {
                            columns.push(this.table.columnOption(i));
                        }
                        const gridData: any = angular.copy(this.table.getSelectedRowsData())

                        this.$scope.options.buttonsOptions.onOpenMassAssignedConfigurationProfile(PopupType.LOCATION_POPUP, gridData, columns)
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.DEVICES, this.userSession),
                    hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MassSendConfigurationProfile),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.locationConfigurationMultiplePermissions
            })
        }

        if (this.$scope.options.buttonsOptions.addTaskMultiple && this.$scope.options.buttonsOptions.taskMultiplePermissions) {
            buttons.push({
                name: 'taskMultipleButton',
                options: {
                    onClick: () => {
                        var columnCount = this.table.columnCount()
                        var columns = []

                        for (var i = 0; i < columnCount; i++) {
                            columns.push(this.table.columnOption(i));
                        }
                        var gridData = angular.copy(this.table.getSelectedRowsData())

                        this.$scope.$root.$broadcast(EventsNames.OPEN_LOCATION_CREATE_ISSUES_TASKS_POPUP, PopupType.TASK_POPUP, gridData, columns)
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.TASKS, this.userSession),
                    hint: i18n('Common', 'MassTaskCreate'),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.taskMultiplePermissions
            })
        }

        if (this.$scope.options.buttonsOptions.addIssueMultiple && this.$scope.options.buttonsOptions.issueMultiplePermissions) {
            buttons.push({
                name: 'issueMultipleButton',
                options: {
                    onClick: () => {
                        var columnCount = this.table.columnCount()
                        var columns = []

                        for (var i = 0; i < columnCount; i++) {
                            columns.push(this.table.columnOption(i));
                        }
                        var gridData = angular.copy(this.table.getSelectedRowsData())

                        this.$scope.$root.$broadcast(EventsNames.OPEN_LOCATION_CREATE_ISSUES_TASKS_POPUP, PopupType.ISSUE_POPUP, gridData, columns)
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.ISSUES, this.userSession),
                    hint: i18n('Common', 'MassIssueCreate'),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.issueMultiplePermissions
            })
        }

        if (this.$scope.options.buttonsOptions.assigningToGroupMultiple && this.$scope.options.buttonsOptions.assigningToGroupPermisions) {
            buttons.push({
                name: 'assigningToGroupMultipleButton',
                options: {
                    onClick: () => {
                        var columnCount = this.table.columnCount()
                        var columns = []

                        for (var i = 0; i < columnCount; i++) {
                            columns.push(this.table.columnOption(i));
                        }
                        var gridData: any[] = angular.copy(this.table.getSelectedRowsData())
                        var diffDistributors = false
                        if (gridData.length > 1) {
                            var prev = gridData[0].referenceId
                            gridData.forEach(item => {
                                if (item.referenceId != prev) {
                                    diffDistributors = true
                                    return
                                }
                            })
                        }
                        if (!diffDistributors) {
                            this.$scope.$root.$broadcast(EventsNames.OPEN_MASS_GROUPS_EDIT_POPUP, gridData)
                        } else {
                            CommonHelper.openInfoPopup(i18n('Popup', 'EditIsEnableWithinOneDistributor'), 'warning')
                        }
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.SWAP_HORIZ, this.userSession),
                    hint: i18n('Common', 'MassGroupAssigning'),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.assigningToGroupPermisions
            })
        }

        if (this.$scope.options.buttonsOptions.alarmDefsMultiplePermissions && this.$scope.options.buttonsOptions.alarmDefsMultipleId) {
            buttons.push({
                name: 'alarmDefsMultipleButton',
                options: {
                    onClick: () => {
                        var columnCount = this.table.columnCount()
                        var columns = []

                        for (var i = 0; i < columnCount; i++) {
                            columns.push(this.table.columnOption(i));
                        }
                        var gridData = angular.copy(this.table.getSelectedRowsData())

                        var tempCol = 10018
                        columns.some(c => {
                            if (c.dataField.indexOf("10018") !== -1) {
                                tempCol = c.dataField
                                return true
                            }
                        })

                        if (gridData && gridData.length > 0) {
                            var tempType = gridData[0][tempCol]

                            if (gridData.every((f) => f[tempCol] == tempType)) {
                                this.api.meter.getAlarmDefs(gridData[0].id).then(alarmDefs => {
                                    if (alarmDefs) {
                                        var alarmDefsRet = alarmDefs.values ? alarmDefs.values : []

                                        alarmDefsRet = alarmDefsRet.map((alarmDef) => {
                                            alarmDef.id = +alarmDef.id
                                            alarmDef.showDef = true
                                            return alarmDef
                                        })

                                        var definitionsBridge = {
                                            items: alarmDefsRet,
                                            popupTitle: i18n('Common', 'AlarmDefsBulkSave'),
                                            onSubmit: null,
                                            idMeter: gridData[0].id,
                                            originalDefs: alarmDefsRet
                                        }

                                        this.$scope.$root.$broadcast(EventsNames.OPEN_METER_DEFINITIONS_EDIT_POPUP + this.$scope.options.buttonsOptions.alarmDefsMultipleId, true, gridData, definitionsBridge, columns)
                                    }
                                })

                            } else {
                                CommonHelper.openInfoPopup(i18n('Common', 'AlarmDefsAllMetersSameClassWarning'), "warning")
                            }
                        }

                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.ALARMS, this.userSession),
                    hint: i18n('Common', 'AlarmDefsBulkSave'),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.alarmDefsMultiplePermissions
            })
        }

        if (this.$scope.options.buttonsOptions.onShowPreview) {
            buttons.push({
                name: 'showPreviewButton',
                options: {
                    onClick: e => {
                        if (this.$scope.options.buttonsOptions.onShowPreview()) {
                            this.showPosisionPopover('#showPreviewButton' + this.$scope.tableId)
                        } else {
                            if (this.mapHeaderButton) {
                                this.mapHeaderButton.option('hint', i18n("Grid", "ShowMap"))
                            }

                            if (this.previewHeaderButton) {
                                this.previewHeaderButton.option('hint', i18n("Grid", "SetPreviewPosition"))
                            }
                            this.$scope.needPositionPopover = false
                        }
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.DETAILS_PREVIEW, this.userSession),
                    onInitialized: e => {
                        this.previewHeaderButtonDeferred = this.$q.defer<DevExpress.ui.dxButton>()
                        this.previewHeaderButton = e.component
                        this.previewHeaderButtonDeferred.resolve(e.component)
                    },
                    hint: i18n("Grid", "ShowPreview")
                }
            })
        }

        if (this.$scope.options.buttonsOptions.onShowMap) {
            buttons.push({
                name: 'showMapButton',
                options: {
                    onClick: e => {
                        if (this.$scope.options.buttonsOptions.onShowMap()) {
                            this.showPosisionPopover('#showMapButton' + this.$scope.tableId)
                        } else {
                            if (this.previewHeaderButton) {
                                this.previewHeaderButton.option('hint', i18n("Grid", "ShowPreview"))
                            }

                            if (this.mapHeaderButton) {
                                this.mapHeaderButton.option('hint', i18n("Grid", "SetMapPosition"))
                            }
                        }
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.MAP, this.userSession),
                    onInitialized: e => {
                        this.mapHeaderButtonDeferred = this.$q.defer<DevExpress.ui.dxButton>()
                        this.mapHeaderButton = e.component
                        this.mapHeaderButtonDeferred.resolve(e.component)
                    },
                    hint: i18n("Grid", "ShowMap")
                }
            })
        }

        if (this.$scope.options.buttonsOptions.onGenerateReportClick && this.$scope.options.buttonsOptions.generateReportPermissions) {
            buttons.push({
                name: "generateReportButton",
                options: {
                    onClick: e => {
                        this.$scope.options.buttonsOptions.onGenerateReportClick(e)
                        this.buttonsListPopover.hide()
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.REPORT_GENERATE, this.userSession),
                    hint: i18n("Grid", "GenerateReport"),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.generateReportPermissions
            })
        }

        if (this.$scope.options.buttonsOptions.showDetailsPermissions) {
            buttons.push({
                name: "showDetailsButton",
                options: {
                    onClick: e => {
                        if (this.$scope.options.buttonsOptions.onShowClick) {
                            this.$scope.options.buttonsOptions.onShowClick(e)
                        }

                        if (this.buttonsListPopover) {
                            this.buttonsListPopover.hide()
                        }
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.DETAILS, this.userSession),
                    hint: i18n("Grid", "ShowDetails"),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.showDetailsPermissions
            })
        }

        if (this.$scope.options.buttonsOptions.addPermissions) {
            buttons.push({
                name: "addButton",
                options: {
                    onClick: e => {
                        if (this.$scope.options.buttonsOptions.onAddClick) {
                            this.$scope.options.buttonsOptions.onAddClick(null)
                        }
                    },
                    onInitialized: e => {
                        this.addButton = e.component
                        var req = this.getRequest(1000, 1, false)
                        if (this.$scope.options.name != null) {
                            if (this.$scope.options.patternsProviderOptions != null) {
                                this.$scope
                                    .options
                                    .patternsProviderOptions
                                    .patternsProvider()
                                    .then((objects: any[]) => {
                                        if (_.size(objects) > 0) {
                                            const request: GridRequestModel = new GridRequestModel()
                                            request.columns = this.$scope.options.columnsDictionary
                                            request.pageNumber = 1
                                            request.pageSize = TypeHelper.MAX_INT_VALUE
                                            request.where = null

                                            const result: {
                                                objects: any[],
                                                totalCount: number,
                                                error: { code: any, msg: string }
                                            } =
                                            {
                                                objects: objects,
                                                totalCount: objects.length,
                                                error: null
                                            }

                                            const gridModel: GridModel = this.createGridModel(request, result)

                                            this.addButton.option("onClick", this.showHideAddButtonPopover)

                                            const items: any[] = this.createItemsAddList(gridModel, (this.$scope.options.patternsProviderOptions.displayField || '').toLowerCase())

                                            this.refreshAddList(items)
                                        }
                                    })
                                    .fail((error: any) => {
                                        this.logger.log(error)
                                    })
                            } else {
                                // TODO!!! Pozbyć się switch case
                                switch (this.$scope.options.name) {
                                    case "LocationsGrid":
                                        this.localDictionary.getColumnForDataType([CommonHelper.locationColumnId, CommonHelper.locationPatternColumnId], CommonHelper.IdLocation).then(columns => {
                                            if (columns && columns.length > 0) {
                                                var idLocation = columns.filter(col => col.id == CommonHelper.locationColumnId)[0]
                                                var idLocationPattern = columns.filter(col => col.id == CommonHelper.locationPatternColumnId)[0]

                                                if (idLocation && idLocationPattern) {
                                                    req.where = "([" + idLocation.name.toUpperCase() + "] = [" + idLocationPattern.name.toUpperCase() + "])"
                                                    this.$scope.options.request(req).then((result: GridModel) => {
                                                        if (result && result.values && result.values.length > 0) {
                                                            this.addButton.option("onClick", this.showHideAddButtonPopover)
                                                            var items = this.createItemsAddList(result, "loc1_1_0")
                                                            this.refreshAddList(items)
                                                        }
                                                    }).catch(reason => this.logger.log(reason))
                                                }
                                            }
                                        })
                                        break

                                    case "MetersGrid":
                                        this.localDictionary.getColumnForDataType([CommonHelper.meterColumnId, CommonHelper.meterPatternColumnId], CommonHelper.IdMeter).then(columns => {
                                            if (columns && columns.length > 0) {
                                                var idMeter = columns.filter(col => col.id == CommonHelper.meterColumnId)[0]
                                                var idMeterPattern = columns.filter(col => col.id == CommonHelper.meterPatternColumnId)[0]

                                                if (idMeter && idMeterPattern) {
                                                    req.where = "([" + idMeter.name.toUpperCase() + "] = [" + idMeterPattern.name.toUpperCase() + "])"
                                                    this.$scope.options.request(req).then((result: GridModel) => {
                                                        if (result && result.values && result.values.length > 0) {
                                                            this.addButton.option("onClick", this.showHideAddButtonPopover)
                                                            var items = this.createItemsAddList(result, "name")
                                                            this.refreshAddList(items)
                                                        }
                                                    }).catch(reason => this.logger.log(reason))
                                                }
                                            }
                                        })
                                        break
                                }
                            }
                        }
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.ADD, this.userSession),
                    hint: i18n("Grid", "Add")
                },
                permissions: this.$scope.options.buttonsOptions.addPermissions
            })
        }

        if (this.$scope.options.buttonsOptions.editPermissions) {
            buttons.push({
                name: "editButton",
                options: {
                    onClick: e => {
                        if (this.$scope.options.buttonsOptions.onEditClick)
                            this.$scope.options.buttonsOptions.onEditClick(e)
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.EDIT, this.userSession),
                    hint: i18n("Grid", "Edit"),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.editPermissions
            })
        }

        if (this.$scope.options.buttonsOptions.depositoryContentEditPermission) {
            buttons.push({
                name: "depositoryContentEditButton",
                options: {
                    onClick: e => {
                        if (this.$scope.options.buttonsOptions.onDepositryContentEdit)
                            this.$scope.options.buttonsOptions.onDepositryContentEdit(e)
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.SWAP_HORIZ, this.userSession),
                    hint: i18n("Common", "DepositoryStateEdit"),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.depositoryContentEditPermission
            })
        }

        if (this.$scope.options.buttonsOptions.groupingLocationAssignLocationsPermission) {
            buttons.push({
                name: "groupingLocationAssignLocationButton",
                options: {
                    onClick: e => {
                        if (this.$scope.options.buttonsOptions.onGroupingLocationAssignLocations)
                            this.$scope.options.buttonsOptions.onGroupingLocationAssignLocations(e)
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.SWAP_HORIZ, this.userSession),
                    hint: i18n("Common", "AssignLocations"),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.groupingLocationAssignLocationsPermission
            })
        }

        if (this.$scope.options.buttonsOptions.deletePermissions) {
            buttons.push({
                name: "deleteButton",
                options: {
                    onClick: e => {
                        if (this.$scope.options.buttonsOptions.onDeleteClick)
                            this.$scope.options.buttonsOptions.onDeleteClick(e)
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.DELETE, this.userSession),
                    hint: i18n("Grid", "Delete"),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.deletePermissions
            })
        }

        if (this.$scope.options.buttonsOptions.deleteRows) {
            buttons.push({
                name: "deleteRowsButton",
                options: {
                    onClick: e => {
                        $('.dx-button').blur()
                        var keys: any[] = this.table.getSelectedRowKeys()
                        keys.forEach(key => {
                            this.table.getDataSource().store().remove(key)
                        })
                        this.table.refresh()
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.DELETE, this.userSession),
                    hint: i18n("Grid", "Delete"),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                }
            })
        }

        if (!this.isLocalDataSource &&
            ((!this.$scope.options.dataSource && !this.$scope.options.buttonsOptions.isRefreshButonHidden == true) ||
                (this.isDashboardButtonVisible(Buttons.Refresh) && !this.$scope.options.buttonsOptions.isRefreshButonHidden == true))
        ) {
            buttons.push({
                name: "refreshButton",
                options: {
                    onClick: () => {
                        try {
                            if (this.table)
                                this.table.refresh()
                        } catch (e) {
                            this.problemInTable(e)
                        }
                        $('.dx-button').blur()
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.REFRESH, this.userSession),
                    hint: i18n("Grid", "Refresh")
                }
            })
        }

        if ((this.$scope.options.buttonsOptions.problemConfirmation && this.$scope.options.buttonsOptions.problemConfirmationPermissions) ||
            this.isDashboardButtonVisible(Buttons.ProblemConfirmation) && this.$scope.options.buttonsOptions.problemConfirmationPermissions) {
            buttons.push({
                name: "problemConfirmationButton",
                options: {
                    onClick: () => {
                        if (this.$scope.options.buttonsOptions.onProblemConfirmationClick)
                            this.$scope.options.buttonsOptions.onProblemConfirmationClick()
                        $('.dx-button').blur()
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.ACTIONS, this.userSession),
                    hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfirmExceptions),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.problemConfirmationPermissions
            })
        }

        if ((this.$scope.options.buttonsOptions.planDelivery && this.$scope.options.buttonsOptions.planDeliveryPermissions) ||
            this.isDashboardButtonVisible(Buttons.PlanDelivery) && this.$scope.options.buttonsOptions.planDeliveryPermissions) {
            buttons.push({
                name: "planDeliveryButton",
                options: {
                    onClick: () => {
                        if (this.$scope.options.buttonsOptions.onPlanDeliveryClick)
                            this.$scope.options.buttonsOptions.onPlanDeliveryClick()
                        $('.dx-button').blur()
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.QUERY_BUILDER, this.userSession),
                    hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PlanDelivery),
                    bindingOptions: {
                        disabled: 'nothingSelected'
                    }
                },
                permissions: this.$scope.options.buttonsOptions.planDeliveryPermissions
            })
        }

        if ((this.$scope.options.importOptions && this.$scope.options.buttonsOptions.importPermissions) ||
            (this.isDashboardButtonVisible(Buttons.Import) && this.$scope.options.importOptions)) {
            let importButtonHint: string = this.getLocalizedText(this.localizationText.NoAvailablePlugins)
            const buttonDefer: ng.IDeferred<DevExpress.ui.dxButton> = this.$q.defer<DevExpress.ui.dxButton>()
            const importButtonOptions: DevExpress.ui.dxButtonOptions = {
                onClick: () => {
                    this.$scope.needImport = true
                    this.$timeout(() => {
                        this.$scope.$broadcast(EventsNames.OPEN_IMPORT_POPUP + this.$scope.tableId, !this.$scope.isLargeGridHeader)
                    })
                },
                hint: importButtonHint,
                template: TemplateHelper.getIcon(ConfigHelper.Icon.IMPORT, this.userSession),
                disabled: true,
                onInitialized: e => {
                    buttonDefer.resolve(e.component)
                }
            }
            // Cutom methods for button
            importButtonOptions['getDynamicTitle'] = () => {
                return importButtonHint
            }
            // ---
            const importButton = {
                name: "importButton",
                options: importButtonOptions,
                permissions: this.$scope.options.buttonsOptions.importPermissions
            }
            this.userSession
                .getDataProvider().Operator
                .getOperatorSettings(this.userSession.getIdLoggedOperator(), [Enums.SimaxOperatorSetting.ImportPlugin])
                .then(settings => {
                    let plugins: OpImportPlugin[] = settings[0]

                    this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ImportPlugins), plugins);

                    const filteredPlugins: OpImportPlugin[] = _.filter(plugins, plugin => plugin.type == this.$scope.options.importOptions.referenceType)
                    const hint: string = (!filteredPlugins || filteredPlugins.length == 0) ? this.getLocalizedText(this.localizationText.NoAvailablePlugins) : this.getLocalizedText(this.localizationText.Import)
                    const newButtonOptions = {
                        hint,
                        disabled: (!filteredPlugins || filteredPlugins.length == 0)
                    }
                    importButtonHint = hint
                    buttonDefer.promise.then((button: DevExpress.ui.dxButton) => {
                        button.option(newButtonOptions)
                    })
                })

            buttons.push(importButton)
        }

        if (this.$scope.options.buttonsOptions.exportPermissions || this.isDashboardButtonVisible(Buttons.Export)) {
            if (this.$scope.options.exportOptions == null) {
                this.$scope.options.exportOptions = {
                    referenceType: this.$scope.options.idReferenceType
                }
            }

            if (this.$scope.options.exportOptions.pluginOptions != null) {
                this.$scope.options.exportOptions.pluginOptions.popoverTarget = '#exportButton' + this.$scope.tableId
            }

            this.$scope.options.exportOptions.onInitialized = (exporter: ExportController) => {
                this.exporter = exporter
            }

            this.$scope.needExport = true

            buttons.push({
                name: "exportButton",
                options: {
                    hint: i18n("Grid", "Export"),
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.EXPORT, this.userSession),

                    onClick: (e: any) => {

                        this.$scope.options.exportOptions.onExportStarted = () => {
                            if (e.component._tempTemplates[0].source == e.component._options.template) {
                                e.component.option("template", `<div class='row grid__dropdown-list-button'><div class='icon-row'><div dx-load-indicator="{height: 19, width: 19}"></div></div><span class='grid__dropdown-list-button-span'>{{$root.i18n("Common", "Downloading")}}</span></div>`)
                                e.component.option("disabled", true)

                                ToastHelper.showInfo(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PleaseWait), { displayTime: ToastHelper.DisplayTime.Short })
                            }
                        }

                        this.$scope.options.exportOptions.onExportFinished = () => {
                            if (e.component._tempTemplates.length != 0) {
                                e.component.option("disabled", false)
                                e.component.option("template", e.component._tempTemplates[0].source)
                            }
                        }

                        this.export()
                    },
                },
                permissions: this.$scope.options.buttonsOptions.exportPermissions
            })
        }

        if (!this.isDashboardButtonSettingsPresent(Buttons.FitColumns) || this.isDashboardButtonVisible(Buttons.FitColumns)) {
            buttons.push({
                name: "columnFixingButton",
                options: {
                    onClick: () => {
                        this.changeColumnFixing()
                        this.colorFixingButton()
                        $('.dx-button').blur()
                    },
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.FORMAT_INCREASE, this.userSession),
                    hint: i18n('Grid', 'ColumnFixing')
                }
            })
        }
        if (!this.$scope.options.buttonsOptions.isSelectButtonHidden == true) {
            buttons.push({
                name: "selectionButton",
                options: {
                    onClick: () => {
                        this.$scope.needSelectionPopover = true
                        this.$timeout(() => {
                            this.selectionPopoverDeferred.promise.then(() => {
                                this.$scope.isSelectionPopoverVisible = !this.$scope.isSelectionPopoverVisible
                                this.selectionPopover.option({
                                    position: 'bottom',
                                    visible: this.$scope.isSelectionPopoverVisible
                                })
                                if (!this.$scope.isSelectionPopoverVisible) {
                                    $('.dx-button').blur()
                                }
                            })
                        })
                    },
                    hint: i18n("Grid", "Selection"),
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.SELECTION, this.userSession)
                }
            })
        }

        if ((this.$scope.options.type == GridTypes.MAIN) ||
            this.isDashboardButtonSettingsPresent(Buttons.ColumnChooser) || this.isDashboardButtonSettingsPresent(Buttons.ColumnConfiguration) || this.isDashboardButtonSettingsPresent(Buttons.AutoFilterRow)) {
            if (!this.isDashboardButtonSettingsPresent(Buttons.ColumnChooser) || this.isDashboardButtonVisible(Buttons.ColumnChooser)) {
                buttons.push({
                    name: "columnChooserButton",
                    options: {
                        onClick: () => {
                            this.table.showColumnChooser()
                            this.$timeout(() => {
                                this.setColumnChooserTooltip()
                            }, 500)
                        },
                        hint: i18n("Grid", "ColumnChooser"),
                        template: TemplateHelper.getIcon(ConfigHelper.Icon.COLUMN_CHOOSER, this.userSession)
                    }
                })
            }

            if ((this.$scope.options.buttonsOptions.saveColumnSettingsPermissions) ||
                this.isDashboardButtonVisible(Buttons.ColumnConfiguration)) {
                buttons.push({
                    name: "saveColumnSettingsButton",
                    options: {
                        onClick: () => {
                            this.$scope.needSaveColumnSettings = true
                            this.$timeout(() => {
                                this.$scope.$broadcast(EventsNames.SHOW_SAVE_COLUMN_SETTINGS + this.$scope.tableId, this.$scope.isLargeGridHeader)
                            })
                        },
                        hint: i18n("Grid", "ColumnConfiguration"),
                        template: TemplateHelper.getIcon(ConfigHelper.Icon.COLUMN_SETTINGS, this.userSession)
                    },
                    permissions: this.$scope.options.buttonsOptions.saveColumnSettingsPermissions
                })
            }
        }

        if ((this.$scope.options.type == GridTypes.MAIN) || this.$scope.options.needCustomFilter ||
            this.isDashboardButtonSettingsPresent(Buttons.ColumnChooser) || this.isDashboardButtonSettingsPresent(Buttons.ColumnConfiguration) || this.isDashboardButtonSettingsPresent(Buttons.AutoFilterRow)) {
            buttons.push({
                name: "filterButton",
                options: {
                    onClick: () => {
                        this.$scope.needCustomFilter = true
                        this.$timeout(() => {
                            if (this.$scope.isLargeGridHeader) {
                                this.$scope.isCustomFilterPopoverVisible = !this.$scope.isCustomFilterPopoverVisible
                                this.filterPopover.toggle(this.$scope.isCustomFilterPopoverVisible)
                                if (!this.$scope.isCustomFilterPopoverVisible) {
                                    $('.dx-button').blur()
                                    this.isButtonListClickedOff = true
                                }
                            } else {
                                this.$scope.isFilterListPopupVisible = true
                            }
                        })
                    },
                    hint: i18n("Grid", "CustomFiltering"),
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.FILTER, this.userSession)
                }
            })
        }

        if (this.$scope.options.showDatatypeLegend) {
            buttons.push({
                name: "datatypeLegendButton",
                options: {
                    onClick: () => {
                        this.$scope.isLegendShown = !this.$scope.isLegendShown
                        if (this.$scope.options.name != null)
                            OperatorLayoutSettings.setSetting('IS_SHOWN_GRID_DATATYPE_LEGEND_' + this.$scope.options.name, this.$scope.isLegendShown)
                    },
                    hint: i18n('Common', 'Legend'),
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.LEGEND, this.userSession)
                }
            })
        }

        // do wywalenia po przerobieniu modulu operatorsw
        if (this.$scope.options.buttonsOptions.showCopyButtonPermissions) {
            buttons.push({
                name: this.$scope.options.buttonsOptions.copyButtonText || 'copyOperator',
                options: {
                    hint: this.$scope.options.buttonsOptions.copyButtonText,
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.CONTENT_COPY, this.userSession),

                    bindingOptions: {
                        disabled: 'nothingSelected'
                    },

                    onClick: () => {
                        this.$scope.options.buttonsOptions.copyOperator = true
                        this.$scope.options.buttonsOptions.onEditClick(this.table.getSelectedRowsData()[0][CommonHelper.idField])

                        if (this.$scope.options.buttonsOptions.onCopyClick) {
                            this.$scope.options.buttonsOptions.onCopyClick(null)
                        }
                    },
                },

                permissions: this.$scope.options.buttonsOptions.showCopyButtonPermissions
            })
        }

        if (this.$scope.options.buttonsOptions.toggleDetailsRowsButtonVisible) {
            buttons.push({
                name: "toggleDetailsRows",
                options: {
                    onClick: this.onToggleDetailsRowsClick,
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.SWAP_VERT, this.userSession),
                    hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ToggleDetailsRows)
                }
            })
        }

        return buttons
    }

    private createItemsAddList(result: any, field: string) {
        var items = []

        items.push({
            name: i18n("Common", "Empty"),
            active: true,
            options:
            {
                hint: i18n("Common", "Empty"),
                onClick: e => {
                    if (this.$scope.options.buttonsOptions.onAddClick)
                        this.$scope.options.buttonsOptions.onAddClick(null)
                    this.showHideAddButtonPopover()
                }
            },

        })

        result.values.forEach(item => {
            items.push({
                name: item[field],
                active: true,
                options:
                {
                    hint: item[field],
                    onClick: e => {
                        if (this.$scope.options.buttonsOptions.onAddClick)
                            this.$scope.options.buttonsOptions.onAddClick(item.id)
                        this.showHideAddButtonPopover()
                    }
                },
            })
        })

        return items
    }

    private refreshAddList(items: any) {
        if (!this.addButtonsList) {
            this.$scope.addButtonsListOptions.items = items
        }

        if (this.addButtonsList) {
            this.addButtonsList.option('items', items)
            this.addButtonsList.repaint()
        }
    }

    //#region Grid Objects

    /**
     * Returns the business object attached to the given grid object.
     */
    public getSourceObject(gridObject: any): TSource {
        if (gridObject != null) {
            const sourceObjectJSON: any = gridObject[GridService.SOURCE_OBJECT_FIELD_NAME]

            if (this.$scope.options.skipDataSourceSerialization) {
                return sourceObjectJSON
            }

            if (this.$scope.options.idReferenceType != null) {
                return ReferenceTypeComponent.createReferenceObject(this.$scope.options.idReferenceType, sourceObjectJSON) as any
            }

            if (this.sourceObjectConstructor != null) {
                return new this.sourceObjectConstructor(sourceObjectJSON)
            }
        }

        return null
    }

    private prepareGridObjects(sourceObjects: TSource[], columns: ColumnModel[]): any[] {
        let preparedObjects: any = sourceObjects

        preparedObjects = this.prependAdditionalSourceObjects(preparedObjects)

        if (!this.$scope.options.idReferenceType) {
            this.setSourceObjectConstructor(sourceObjects)
        }

        preparedObjects = this.createGridObjects(preparedObjects, columns)
        preparedObjects = this.filterGridObjects(preparedObjects)

        return preparedObjects
    }

    private createGridObjects(sourceObjects: TSource[], columns: ColumnModel[]): any[] {
        const propertiesSource: GridDataSourceType = this.$scope.options.dataSourceType != null
            ? this.$scope.options.dataSourceType
            : this.DEFAULT_DATA_SOURCE_PROPERTIES_SOURCE_VALUE

        return sourceObjects.map((sourceObject: TSource, index: number) => {
            let result: any = {};
            let parseInfo: { sourceObject?: any, additionalFields?: { key: string, value: any }[] } = null

            if (this.$scope.options.dataSourceParser) {
                parseInfo = this.$scope.options.dataSourceParser(sourceObject, index)
            }

            let parsedSourceObject = sourceObject

            if (parseInfo && parseInfo.sourceObject) {
                parsedSourceObject = parseInfo.sourceObject
            }

            switch (propertiesSource) {
                case GridDataSourceType.Auto:
                    if (TypeHelper.hasDynamicValues(parsedSourceObject)) {
                        result = this.prepareDynamicValuesGridObject(parsedSourceObject)
                    } else {
                        result = this.preparePropertiesGridObject(parsedSourceObject, columns)
                    }

                    break

                case GridDataSourceType.DynamicValues:
                    if (TypeHelper.hasDynamicValues(parsedSourceObject)) {
                        result = this.prepareDynamicValuesGridObject(parsedSourceObject)
                    }

                    break

                case GridDataSourceType.Properties:
                    result = this.preparePropertiesGridObject(parsedSourceObject, columns)
                    break
            }

            // Set id, parent id and name

            result[this.GRID_ID_FIELD_NAME] = this.getDataSourceId(parsedSourceObject)
            result[this.GRID_NAME_FIELD_NAME] = sourceObject.toString()

            if (parseInfo && parseInfo.sourceObject) {
                result[this.GRID_PARENT_OBJECT_ID_FIELD_NAME] = this.getParentDataSourceId(sourceObject)
            }

            // Set additional properties
            if (parseInfo && parseInfo.additionalFields) {
                parseInfo.additionalFields.forEach((additionalFields: { key: string, value: any }) => {
                    result[additionalFields.key] = additionalFields.value
                })
            } else if (this.$scope.options.dataSourceAdditionalFields && this.$scope.options.dataSourceAdditionalFields.length > 0) {
                this.$scope.options.dataSourceAdditionalFields.forEach(af => {
                    result[af.name] = af.map(parsedSourceObject)
                })
            }

            this.attachSourceObject(sourceObject, result)

            return result;
        })
    }

    /**
     * Attaches the source business object onto the given grid object.
     */
    private attachSourceObject(sourceObject: TSource, gridObject: any): void {
        if (this.$scope.options.skipDataSourceSerialization) {
            gridObject[GridService.SOURCE_OBJECT_FIELD_NAME] = sourceObject
        }
        else if (TypeHelper.isIJSONSerializable(sourceObject)) {
            gridObject[GridService.SOURCE_OBJECT_FIELD_NAME] = (sourceObject as any).toJSON()
        }
        else {
            console.warn(this.LOG_STRING, 'The given source object is not IJSONSerializable. Unable to attach it to grid object.');

            gridObject[GridService.SOURCE_OBJECT_FIELD_NAME] = null
        }
    }

    /**
     * Sets a source object constructor based on sourceObjects or prependedObjects.
     */
    private setSourceObjectConstructor(sourceObjects: TSource[]): void {
        if (sourceObjects.length > 0) {
            this.sourceObjectConstructor = Object.getPrototypeOf(sourceObjects[0]).constructor
        } else if (this.prependedItems.length > 0) {
            this.sourceObjectConstructor = Object.getPrototypeOf(this.prependedItems[0]).constructor
        }
    }

    /**
     * Prepares a grid object from sourceObject's dynamicValues property.
     */
    private prepareDynamicValuesGridObject(sourceObject: TSource): any {
        const gridObject: any = {}

        TypeHelper.copyDynamicValues(sourceObject, gridObject)

        _.forEach(gridObject, (value: any, key: string) => {

            // Converting MS date to ISO date because filters are incorrectly interpreting it.
            if (ConvertHelper.isNetDateFormat(value)) {
                gridObject[key] = ConvertHelper.stringToDate(value).toISOString()
            }
        })

        return gridObject
    }

    /**
     * Prepares a grid object from sourceObject's properties filtered by columns.
     */
    private preparePropertiesGridObject(source: TSource, columns?: ColumnModel[]): void {
        const gridObject: any = {}
        const sourceFields: string[] = _.isArray(columns) ? columns.map(this.getDataField) : _.keys(source)

        sourceFields.forEach((field: string) => {
            gridObject[field] = source[field]
        })

        return gridObject
    }

    private filterGridObjects(gridObjects: any[]): any[] {
        if (this.$scope.options.gridItemFilter) {
            return gridObjects.filter((gridObject: any) => this.$scope.options.gridItemFilter(gridObject))
        }

        return gridObjects
    }

    /**
     * Returns the id of the source object attached to the given grid object 
     */
    private getSourceObjectId(gridObject: any): number {
        return gridObject[this.GRID_PARENT_OBJECT_ID_FIELD_NAME] || gridObject[this.GRID_ID_FIELD_NAME]
    }

    /**
     * Prepends items from {@see prependedItems} into the given array of grid objects
     */
    private prependAdditionalSourceObjects(sourceObjects: TSource[]): TSource[] {
        if (this.prependedItems.length > 0) {
            return this.prependedItems.concat(sourceObjects)
        }

        return sourceObjects
    }

    //#endregion


    private getDataGridOptions(): DevExpress.ui.dxDataGridOptions {
        var onInitializeData: (e) => void
        this.remoteOperations = {
            filtering: true,
            paging: true,
            sorting: true,
            summary: true
        }

        if (TypeHelper.isPromise<any[]>(this.$scope.options.dataSource)) {
            this.setDataSource(this.$scope.options.dataSource)
        } else if (this.$scope.options.dataSource) {
            if (this.$scope.options.dataSource instanceof DataSource) {
                this.dataSource = this.$scope.options.dataSource

                if (!this.$scope.options.ignoreKey && this.dataSource['_store'] && this.dataSource['_store']._array && this.dataSource['_store']._array.every(i => i.id !== undefined)) {
                    this.dataSource['_store']._key = 'id'
                }

                this.isFilteredLocally = true
            } else {
                this.setDataSource(this.$scope.options.dataSource)
            }
        } else if (this.$scope.options.getDataSource) {
            this.setGetDataSource(this.$scope.options.getDataSource)
        } else if ((this.$scope.options.request && this.$scope.options.request.length) || this.$scope.options.getDataSourceMethod) {
            // Load options and data source
            var customStore: DevExpress.data.CustomStoreOptions = {
                load: (options: DevExpress.data.LoadOptions) => {
                    if (this.$scope.options.onDataLoad) {
                        this.$scope.options.onDataLoad()
                    }

                    this.updatePagerInfoText()
                    var deferred = $.Deferred()
                    this.sortData = options.sort
                    this.customFilterColumns()

                    if (options.take) {
                        this.getData((options.skip / options.take) + 1, options.take, data => {
                            if (data) {
                                if (this.$scope.options.onDataReady) {
                                    this.$scope.options.onDataReady(data.values)
                                }
                                deferred.resolve(data.values, { totalCount: data.totalCount })
                            } else {
                                deferred.resolve([], { totalCount: 0 })
                            }
                        })
                    } else {
                        deferred.resolve([])
                    }

                    this.setCustomFilterButtonsState()
                    return deferred.promise()
                }
            }
            if (!this.$scope.options.ignoreKey) {
                customStore.key = 'id'
            }
            customStore['loadMode'] = 'processed'
            customStore['cacheRawData'] = false
            customStore['useDefaultSearch'] = false

            var dataSource = new DataSource(customStore)
            dataSource.pageSize(100)
            this.dataSource = dataSource
        } else {
            this.isFilteredLocally = true
            var dataSourceOptions = {
                store: new ArrayStore({ data: [] })
            }
            var dataSource = new DataSource(dataSourceOptions)
            dataSource.pageSize(100)
            this.dataSource = dataSource
            if (this.$scope.options.onDataReady) {
                this.$scope.options.onDataReady([])
            }

            if (this.$scope.options.request) {
                onInitializeData = e => {
                    this.$scope.show = false
                    this.$scope.options.request().then((result: any[]) => {
                        var dataSourceOptions = {
                            store: new ArrayStore({ data: result })
                        }
                        var dataSource = new DataSource(dataSourceOptions)
                        dataSource.pageSize(100)
                        this.table.option('dataSource', dataSource)
                        this.$timeout(() => {
                            this.$scope.show = true
                        })
                    })
                }
            }
        }

        // Columns
        var columns: DevExpress.ui.dxDataGridColumn[] = undefined

        if (this.$scope.options.columns) {
            this.$scope.options.columns.map(col => TableController.addCustomFiltersToDxColumn(col, col.dataType, col, this.$scope.options.addCustomFilters, this.localDictionary, this.referenceTables, this))
            columns = this.$scope.options.columns
        } else if (this.$scope.options.defaultColumnsDictionary && this.$scope.options.columnsDictionary) {
            this.$scope.options.defaultColumnsDictionary.forEach(defaultColumn => {
                var exist = false
                this.$scope.options.columnsDictionary.forEach(column => {
                    if (defaultColumn.id == column.id && defaultColumn.name == column.name) {
                        exist = true
                    }
                })

                if (!exist) { this.$scope.options.columnsDictionary.push(defaultColumn) }
            })
            columns = this.getDxColumns(this.$scope.options.columnsDictionary, this.$scope.options.defaultColumnsDictionary)
        } else if (this.$scope.options.columnsDictionary) {
            columns = this.getDxColumns(this.$scope.options.columnsDictionary)
        }

        var masterDetail = {
            enabled: this.$scope.options.showShortDetails == true
        }
        if (this.$scope.options.masterDetail) {
            masterDetail = this.$scope.options.masterDetail
        }

        var onContentReady = _.debounce(e => {
            this.onContentReady(e)
        }, 200)

        var $window = angular.element(window)
        this.windowHeight = $window.height()
        this.windowWidth = $window.width()

        if (this.windowHeight > this.windowWidth && this.windowWidth <= 768) {
            this.isMobile = true
        } else if (this.windowHeight < this.windowWidth && this.windowWidth <= 1024) {
            this.isMobile = true
        } else {
            this.isMobile = false
        }

        var gridOptions: DevExpress.ui.dxDataGridOptions = {
            onInitialized: e => {
                this.table = e.component

                if (this.$scope.options.onInitialized) {
                    (e as any).tableId = this.$scope.tableId

                    this.$scope.options.onInitialized(e, this)
                }
                this.table.option({ columnMinWidth: 30 })
                this.tableElement = e.element

                this.setupEvents(e)

                this.tableDeferred.resolve(e.component)
                this.hackForCustomFilters(e)
                if (onInitializeData) { onInitializeData(e) }
            },
            remoteOperations: this.remoteOperations,
            onContentReady: onContentReady,
            columns: columns,
            keyExpr: 'id',
            dataSource: this.dataSource,
            masterDetail: masterDetail,
            height: "100%",
            columnFixing: {
                enabled: false,
                texts: {
                    fix: i18n('Grid', 'Fix'),
                    leftPosition: i18n('Grid', 'LeftPosition'),
                    rightPosition: i18n('Grid', 'RightPosition'),
                    unfix: i18n('Grid', 'Unfix')
                }
            },
            noDataText: this.$scope.options.noDataText ? this.$scope.options.noDataText : i18n('Common', 'NoData'),
            columnChooser: <any>{
                enabled: false,
                emptyPanelText: i18n('Grid', 'ColumnChooserText'),
                title: i18n('Grid', 'ColumnChooserTitle'),
                mode: 'select',
            },
            rowDragging: this.$scope.options.dragging,
            stateStoring: {
                enabled: this.$scope.options.name != null,
                type: "custom",
                storageKey: this.$scope.options.name,
                customLoad: () => {
                    const tableConfig = OperatorLayoutSettings.getSetting('SAVED_TABLE_' + this.$scope.options.name, null)

                    // Setting custom properties
                    if (tableConfig) {
                        this.table.option('columnAutoWidth', tableConfig.columnAutoWidth)
                        // Set resizing mode on 'widget' only if no masterDetails enabled
                        this.table.option('columnResizingMode', this.getResizingMode(tableConfig.columnAutoWidth))
                    }
                    return tableConfig
                },
                customSave: (gridState) => {
                    // Custom saving columnAutoWidth
                    gridState.columnAutoWidth = this.table.option('columnAutoWidth')
                    OperatorLayoutSettings.setSetting('SAVED_TABLE_' + this.$scope.options.name, gridState)
                },
                savingTimeout: 0
            },
            editing: {
                mode: 'cell',
                allowUpdating: true
            },
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            allowColumnReordering: true,
            allowColumnResizing: true,
            sorting: {
                mode: 'multiple',
                ascendingText: i18n('Grid', 'SortAscending'),
                clearText: i18n('Grid', 'ClearSorting'),
                descendingText: i18n('Grid', 'SortDescending')
            },
            groupPanel: {
                visible: false,
                emptyPanelText: i18n('Grid', 'GroupPanelText')
            },
            loadPanel: {
                text: i18n('Grid', 'Loading'),
                enabled: false
            },
            paging: {
                pageSize: this.defaultPageSize,
                enabled: true
            },
            export: {
                enabled: false,
                allowExportSelectedData: true,
                texts: <any>{
                    exportAll: i18n('Grid', 'ExportAll'),
                    exportSelectedRows: i18n('Grid', 'ExportSelectedRows'),
                    exportTo: i18n('Grid', 'ExportFileName')
                }
            },
            filterRow: {
                visible: true,
                showOperationChooser: true,
                betweenEndText: i18n("Common", "End"),
                betweenStartText: i18n("Common", "Start"),
                operationDescriptions: {
                    equal: i18n('Common', 'Equal'),
                    notEqual: i18n('Common', 'NotEqual'),
                    lessThan: i18n('Common', 'LessThan'),
                    lessThanOrEqual: i18n('Common', 'LessThanOrEqual'),
                    greaterThan: i18n('Common', 'GreaterThan'),
                    greaterThanOrEqual: i18n('Common', 'GreaterThanOrEqual'),
                    startsWith: i18n('Common', 'StartsWith'),
                    contains: i18n('Common', 'Contains'),
                    notContains: i18n('Common', 'NotContains'),
                    endsWith: i18n('Common', 'EndsWith'),
                    between: i18n('Common', 'Between')
                },
                resetOperationText: i18n('Common', 'Reset'),
                showAllText: i18n('Common', 'All')
            },
            searchPanel: <any>{
                visible: this.$scope.options.buttonsOptions.enabled,
                placeholder: i18n('Common', 'Search'),
                searchVisibleColumnsOnly: this.$scope.options.searchVisibleColumnsOnly != null ? this.$scope.options.searchVisibleColumnsOnly : true
            },
            scrolling: {
                mode: 'standard',

                // Do not use virtual rendering of columns, because it breaks custom filters (empty, notempty, choose).
                rowRenderingMode: 'virtual'
            },
            pager: {
                visible: 'auto',
                showPageSizeSelector: false,
                showNavigationButtons: false,
                showInfo: false,
                infoText: ((...args: any[]) => this.getPagerInfoTextFunc(...args)) as any,
                allowedPageSizes: this.allowedPageSizes
            },
            columnAutoWidth: this.isMobile ? true : this.$scope.options.columnAutoWidth,
            columnResizingMode: this.getResizingMode(this.$scope.options.columnAutoWidth),
            selection: {
                mode: 'multiple',
                showCheckBoxesMode: 'none',
                selectAllMode: 'page'
            },
            onRowClick: e => {
                if (this.$scope.multiSelectEnabled) {
                    if (this.selectedRows.filter(row => row == e.rowIndex).length) {
                        var index = this.selectedRows.indexOf(e.rowIndex)
                        if (index > -1) {
                            this.selectedRows.splice(index, 1);
                        }
                    } else {
                        this.selectedRows.push(e.rowIndex)
                    }
                    e.component.selectRowsByIndexes(this.selectedRows)
                } else {
                    this.onRowClick(e)
                }
            },
            onContextMenuPreparing: (e: any) => {
                var data = e.component.getSelectedRowsData()
                if (data.length == 0) {
                    return
                } else if (this.$scope.options.onContextMenuPreparing) {
                    this.$scope.options.onContextMenuPreparing(e)
                }
            },
            onSelectionChanged: e => {
                this.onSelectionChanged(e)
            },
            onEditorPreparing: (e: any) => {
                // boolean filter hack
                if (e.parentType === "filterRow" && e.dataType === "boolean") {
                    var undefinedBoolFilter = [e.dataField, "=", null]
                    if (!this.options.request && !this.options.getDataSourceMethod) {
                        undefinedBoolFilter = [[e.dataField, "<>", true], "AND", [e.dataField, "<>", false]]
                    }
                    e.editorOptions.dataSource.store = [
                        true,
                        false,
                        {
                            text: i18n('Common', 'Empty'),
                            undefinedBool: undefinedBoolFilter
                        }
                    ]
                    var valueOnCreate = e.value // fix for refresh when custom value is selected
                    e.editorOptions.displayExpr = (data) => {
                        if (valueOnCreate && valueOnCreate.text) {
                            var text = valueOnCreate.text
                            valueOnCreate = null
                            return text
                        }
                        if (null === data) {
                            return i18n('Common', 'All')
                        } else {
                            if (true === data) {
                                return i18n('Common', 'True')
                            } else {
                                if (false === data) {
                                    return i18n('Common', 'False')
                                } else {
                                    return data.text
                                }
                            }
                        }
                    }
                }
            },
            onCellHoverChanged: (e: any) => {
                if (this.$scope.options.onCellHoverChanged)
                    this.$scope.options.onCellHoverChanged(e)
            }
        }

        if (this.$scope.options.onRowUpdated) {
            gridOptions.onRowUpdated = e => {
                this.$scope.options.onRowUpdated(e)
            }
        }

        if (this.$scope.options.onRowUpdating) {
            gridOptions.onRowUpdating = (e: any) => {
                this.$scope.options.onRowUpdating(e)
            }
        }


        if (this.$scope.options.onRowValidating) {
            gridOptions.onRowValidating = (e: any) => {
                this.$scope.options.onRowValidating(e)
            }
        }

        if (this.$scope.options.onToolbarPreparing) {
            gridOptions.onToolbarPreparing = e => {
                this.$scope.options.onToolbarPreparing(e)
            }
        }

        if (this.$scope.options.onEditingStart) {
            gridOptions.onEditingStart = e => {
                this.$scope.options.onEditingStart(e)
            }
        }

        if (this.$scope.options.onRowPrepared) {
            if (<any>this.$scope.options.onRowPrepared == 'edit') {
                gridOptions.onRowPrepared = (e: any) => {
                    if (e.rowType == "data") {
                        if (e.data.isNew) {
                            $(e.rowElement).css('font-style', 'italic')
                        } else if (e.data.isRemoved) {
                            $(e.rowElement).css('text-decoration', 'line-through')
                        } else if (e.data.isEdited) {
                            $(e.rowElement).css('font-weight', 'bold')
                        }
                    }
                }
            } else {
                gridOptions.onRowPrepared = e => {
                    this.$scope.options.onRowPrepared(e)
                }
            }
        }

        var addColorToRows = this.$scope.options.addColorToRows
        var addColorToCells = this.$scope.options.addColorToCells
        switch (this.$scope.options.type) {
            case GridTypes.MAIN:
                addColorToRows = true
                addColorToCells = true
                gridOptions.loadPanel.enabled = true
                gridOptions.export.enabled = false
                gridOptions.pager.showPageSizeSelector = true
                gridOptions.pager.showInfo = true
                gridOptions.pager.visible = true
                if (this.$scope.options.contextMenuItems) {
                    gridOptions.onContextMenuPreparing = (e: any) => {
                        if (e.row && e.row.rowType === 'data') {
                            if (!this.table.isRowSelected(e.row.key)) {
                                this.table.selectRows(e.row.key, false)
                            }

                            var itemResult = this.$scope.options.contextMenuItems(this.isTouchScreen)

                            if (TypeHelper.isPromise<any[]>(itemResult)) {
                                itemResult.then(items => {
                                    if (items.length > 0) {
                                        e.items = items
                                    }
                                })
                            } else {
                                e.items = itemResult
                            }
                        }
                    }
                }

                this.isShortPagerInfoText = false

                gridOptions.onRowPrepared = (e: any) => {
                    if (this.$scope.options.onRowPrepared && typeof this.$scope.options.onRowPrepared === 'function') {
                        this.$scope.options.onRowPrepared(e)
                    }
                    e.rowElement.on("swiperight", () => {
                        this.selectedRows.push(e.rowIndex)
                        e.component.selectRowsByIndexes(this.selectedRows)
                    })
                    e.rowElement.on("swipeleft", () => {
                        e.component.deselectRows([e.key])
                        var index = this.selectedRows.indexOf(e.rowIndex)
                        if (index > -1) {
                            this.selectedRows.splice(index, 1);
                        }
                    })
                }
                break
            case GridTypes.PAGINATED_SMALL:
                gridOptions.width = '100%'
                gridOptions.editing.allowUpdating = false
                gridOptions.pager.showPageSizeSelector = true
                gridOptions.pager.allowedPageSizes = this.allowedPageSizes
                gridOptions.pager.showInfo = true
                gridOptions.pager.visible = true
                gridOptions.loadPanel.enabled = true

                if (this.$scope.options.contextMenuItems) {
                    gridOptions.onContextMenuPreparing = (e: any) => {
                        if (e.row && e.row.rowType === 'data') {
                            if (!this.table.isRowSelected(e.row.key)) {
                                this.table.selectRows(e.row.key, false)
                            }

                            var itemResult = this.$scope.options.contextMenuItems(this.isTouchScreen)

                            if (TypeHelper.isPromise<any[]>(itemResult)) {
                                itemResult.then(items => {
                                    if (items.length > 0) {
                                        e.items = items
                                    }
                                })
                            } else {
                                e.items = itemResult
                            }
                        }
                    }
                }
                break
            case GridTypes.SMALL:
                gridOptions.width = '100%'
                gridOptions.scrolling.mode = 'virtual'
                gridOptions.editing.allowUpdating = false
                break
            case GridTypes.CREATE_EDIT:
                gridOptions.width = '100%'
                break
            case GridTypes.NO_SEARCH_BAR_SMALL:
                gridOptions.width = '100%'
                gridOptions.scrolling.mode = 'virtual'
                gridOptions.editing.allowUpdating = false
                break
            case GridTypes.NO_SEARCH_BAR_PAGINATED_SMALL:
                gridOptions.width = '100%'
                gridOptions.editing.allowUpdating = false
                gridOptions.pager.allowedPageSizes = [100]
                gridOptions.pager.showInfo = true
                gridOptions.pager.visible = true
                gridOptions.loadPanel.enabled = true

                break
            case GridTypes.NO_SEARCH_BAR_SMALL_SINGLE_PAGE:
                gridOptions.width = '100%'
                gridOptions.scrolling.mode = 'standard'
                gridOptions.paging.enabled = false
                gridOptions.loadPanel.enabled = true
                gridOptions.loadPanel.showIndicator = true
                gridOptions.editing.allowUpdating = true
                gridOptions.editing.mode = 'batch'
                break
        }

        if (addColorToRows) {
            var lastOnRowPrepared = gridOptions.onRowPrepared
            gridOptions.onRowPrepared = (e: any) => {
                if (lastOnRowPrepared) lastOnRowPrepared(e)
                if (['header', 'filter', 'totalFooter'].indexOf(e.rowType) < 0 && e.data && e.data.rowColor) {
                    if (e.data.rowColor >= 0) {
                        e.rowElement.find('td').css('background-color', 'rgba(' + CommonHelper.rbgaToRgbColor(KnownColor.getColor(e.data.rowColor.toString())) + ', 0.65)')
                    } else {
                        e.rowElement.find('td').css('background-color', 'rgba(' + CommonHelper.argbToRGB(e.data.rowColor.toString()) + ', 0.65)')
                    }
                }
            }
        }

        if (addColorToCells) {
            gridOptions.onCellPrepared = (e: any) => {
                if (e.column.dataField && e.rowType == 'data' && e.data.cellColor) {
                    var tmpCellColor: string[] = e.data.cellColor.split(',')
                    var cellColor = tmpCellColor.map(tcc => {
                        tcc = tcc.substring(1, tcc.length - 1)
                        var tmp: string[] = tcc.split(':')
                        return { column: tmp[0].toLowerCase(), value: tmp[1] }
                    })

                    cellColor.forEach(color => {
                        if (e.column.dataField == color.column) {
                            this.$timeout(() => {
                                e.cellElement.css('background-color', 'rgba(' + CommonHelper.rbgaToRgbColor(KnownColor.getColor(color.value)) + ', 0.65)')
                            }, 50)
                        }
                    })
                }
            }
        }

        if (this.$scope.options.export) {
            gridOptions.export = this.$scope.options.export
        }

        if (this.isDashboardButtonSettingsPresent(Buttons.AutoFilterRow) && !this.isDashboardButtonVisible(Buttons.AutoFilterRow)) {
            gridOptions.filterRow.visible = false
        }

        if (this.isDashboardButtonSettingsPresent(Buttons.FullTextSearch) && !this.isDashboardButtonVisible(Buttons.FullTextSearch)) {
            this.$timeout(() => {
                if (this.tableElement) {
                    this.tableElement.find('.dx-datagrid-search-panel').css('display', 'none')
                }
            })
        }

        if (this.$scope.options.paging) {
            gridOptions.paging = this.$scope.options.paging
        }

        if (this.$scope.options.scrolling) {
            gridOptions.scrolling = this.$scope.options.scrolling
        }

        if (this.$scope.options.pager) {
            gridOptions.pager = this.$scope.options.pager
        }

        if (this.$scope.options.height) {
            gridOptions.height = this.$scope.options.height
        } else if (this.$scope.options.height == 'max') {
            this.$scope.options.height = undefined
        }

        if (this.$scope.options.editing) {
            gridOptions.editing = this.$scope.options.editing
        }

        if (this.$scope.options.columnFixing) {
            gridOptions.columnFixing = this.$scope.options.columnFixing
        }

        if (this.$scope.options.allowColumnReordering != null) {
            gridOptions.allowColumnReordering = this.$scope.options.allowColumnReordering
        }

        if (this.$scope.options.filterRow) {
            gridOptions.filterRow = this.$scope.options.filterRow
        }

        if (this.$scope.options.selectedRowKeys) {
            gridOptions.selectedRowKeys = this.$scope.options.selectedRowKeys
        }

        if (this.$scope.options.showColumnHeaders != null) {
            gridOptions.showColumnHeaders = this.$scope.options.showColumnHeaders
        }

        if (this.$scope.options.showColumnLines != null) {
            gridOptions.showColumnLines = this.$scope.options.showColumnLines
        }

        if (this.$scope.options.showRowLines != null) {
            gridOptions.showRowLines = this.$scope.options.showRowLines
        }

        if (this.$scope.options.selection) {
            gridOptions.selection = this.$scope.options.selection
        }

        return gridOptions
    }

    private firstRequest = true
    private isFirstRequestLoad = false
    private getData(pageNumber: number, pageSize: number, callback: (result: GridModel) => void = null) {
        if (this.firstRequest) {
            this.firstRequest = false
            if (this.$scope.options.name != null) {
                var tableConfig = OperatorLayoutSettings.getSetting('SAVED_TABLE_' + this.$scope.options.name, null)
                if (tableConfig && tableConfig.columns && tableConfig.columns.length > 0) {
                    var hasCustomFilter = tableConfig.columns.some(c => {
                        return c.selectedFilterOperation == 'empty' || c.selectedFilterOperation == 'notempty'// TODO: || c.selectedFilterOperation == 'choose'
                    })
                    if (hasCustomFilter) {
                        this.isFirstRequestLoad = true
                        this.table.beginCustomLoading(i18n('Grid', 'Loading'))
                        if (callback) { callback({ values: [], totalCount: 0, errorMessage: null, hasErrorCode: 0 }) }
                        return
                    }
                }
            }
        }
        var req = this.getRequest(pageSize, pageNumber, false)

        if (this.$scope.options.getDataSourceMethod) {
            this.getGridModel(this.$scope.options.getDataSourceMethod, req, this.$scope.options.dataSourceAdditionalFields).then(result => {
                if (this.isFirstRequestLoad) {
                    this.table.endCustomLoading()
                    this.isFirstRequestLoad = false
                }
                if (callback) { callback(result) }
            }).fail(reason => this.logger.log(reason))
        }
        else {
            this.$scope.options.request(req).then((result: GridModel) => {
                if (this.isFirstRequestLoad) {
                    this.table.endCustomLoading()
                    this.isFirstRequestLoad = false
                }
                if (callback) { callback(result) }
            }).catch(reason => this.logger.log(reason))
        }
    }

    private createGridModel(request: GridRequestModel, result: { objects: any[], totalCount: number, error: { code: any, msg: string } }): GridModel {
        const startTime: number = performance.now();

        const gridModel: GridModel = new GridModel()

        gridModel.values = this.prepareGridObjects(result.objects, request.columns)
        gridModel.totalCount = result.totalCount + this.prependedItems.length

        if (result.error && result.error.msg) {//TO DO!!! zmienić to na  docelowy fail z filtra tak jak w sendRequest
            gridModel.hasErrorCode = result.error.code
            gridModel.errorMessage = result.error.msg
            CommonHelper.openInfoPopup(result.error.msg, 'error', 5000)
        }

        const endTime: number = performance.now();

        console.log("getGridModel - Prepare gridModel took " + (endTime - startTime) + " milliseconds.")

        return gridModel
    }

    private getGridModel(filter: (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => JQueryPromise<{ objects: any[], totalCount: number, error: { code: any, msg: string } }>,
        request: GridRequestModel, additionalFields: { name: string, map: <T>(obj: T) => any, }[]) {

        return this
            .beforeRequest()
            .then(() => {
                const columns = request.columns.map(c => new ColumnInfo(c))
                const filterResult = filter(columns, request.pageNumber, request.pageSize, request.where)

                if (TypeHelper.isPromise<any>(filterResult)) {
                    return filterResult.then(result => {
                        return this.createGridModel(request, result)
                    })
                }

                return this.createGridModel(request, {
                    objects: [],
                    totalCount: 0,
                    error: {
                        code: null,
                        msg: null
                    }
                })
            })
    }

    private beforeRequest() {
        //return DataProvider.getOperatorStrings()//DO USUNIECIA!!! - to zapewnione przy logowaniu
        var deferred = $.Deferred<any>()
        deferred.resolve({ idOperator: 0, values: [] })
        return deferred.promise()
    }

    private getResizingMode(isAutoWidth) {
        if (isAutoWidth && (!this.$scope.options.masterDetail || !this.$scope.options.masterDetail.enabled)) {
            return 'widget'
        }
        return 'nextColumn'
    }

    private getRequest(pageSize: number = 0, pageNumber: number = 0, onlyVisibleColumns: boolean = false) {
        let searchText: string
        let columns: ColumnModel[] = []
        const visibleColumns: ColumnModel[] = []
        const columnDict: { [id: string]: number } = {}

        if (this.table) {
            searchText = this.table.option('searchPanel').text
            var dateColumnNames = []
            for (var i = 0; i < this.table.columnCount(); i++) {
                var col = <any>this.table.columnOption(i)
                columnDict[col.dataField] = col.visibleIndex
                col.filterValue = null
                if (col.visible) {
                    var column = _.find(this.$scope.options.columnsDictionary, (element) => {
                        return element.name == col.dataField
                    })
                    if (column) {
                        if (column.type == CommonHelper.datetime) {
                            dateColumnNames.push(column.name)
                        }
                        visibleColumns.push(column)
                    }
                }
            }
        }
        if (onlyVisibleColumns) {
            columns = visibleColumns
        } else {
            columns = this.$scope.options.columnsDictionary
        }

        columns = columns.sort((a, b) => {
            return columnDict[a.name] - columnDict[b.name]
        })

        this.changeDateToUTC = true

        var whereClause = this.getWhereClause(this.table.getCombinedFilter(true))

        this.changeDateToUTC = false
        if (dateColumnNames.length) {
            var pattern = /^([12]{1}\d{3})((-{1}([0]{1}[1-9]?|[1]{1}[0-2]?)?)?(-{1}([0]{1}[1-9]?|[1-2]{1}\d?|[3]{1}[01]?)?)?)?$/g
            var textArray = pattern.exec(searchText)
            if (searchText && textArray) {
                var dates = this.createDateFilter(textArray)
                dateColumnNames.forEach(dateColumn => {
                    var fromWhere = "[" + dateColumn + "] >= '" + dates.startDate + "'"
                    var toWhere = "[" + dateColumn + "] <= '" + dates.endDate + "'"
                    var fromItem = { name: dateColumn, where: fromWhere }
                    var toItem = { name: dateColumn, where: toWhere }
                    whereClause.items.push(fromItem, toItem)
                    if (whereClause.where.length) {
                        whereClause.where = whereClause.where + " or "
                    }
                    whereClause.where = whereClause.where + "(" + fromWhere + " and " + toWhere + ")"
                })
            }
        }
        if (this.customWhereClause && this.customWhereClause.where.length) {
            whereClause.items.push(this.customWhereClause.item)
            if (whereClause.where.length) {
                whereClause.where = whereClause.where + " and "
            }
            whereClause.where = whereClause.where + this.customWhereClause.where
        }

        columns.forEach(c => {
            c.sortDesc = null
            c.where = null
            whereClause.items.forEach((whereCl, index) => {
                if (angular.isArray(whereCl.name)) {
                    whereCl.name.forEach(filter => {
                        if (c.name == filter.name.toLowerCase()) {
                            if (!c.where) {
                                c.where = [filter.where]
                            } else {
                                c.where.push(filter.where)
                            }
                        }
                    })
                } else {
                    if (c.name == whereCl.name.toLowerCase()) {
                        if (!c.where) {
                            c.where = [whereCl.where]
                        } else {
                            c.where.push(whereCl.where)
                        }
                    }
                }
            })
        })

        if (angular.isArray(this.sortData)) {
            var sortArray: any[] = this.sortData
            sortArray.forEach(s => {
                var id = s.selector
                columns.forEach(c => {
                    if (c.name == id.toLowerCase()) {
                        c.sortDesc = s.desc
                    }
                })
            })
        }

        if (this.$state.params['ids'] && this.$state.params['ids'].length > 0 && this.$scope.options.referenceId) {
            var primaryColumn = this.localDictionary.getPrimaryKeyColumn(this.$scope.options.referenceId)
            if (primaryColumn) {
                var fColumns = columns.filter(c => {
                    if (primaryColumn.idDataType == c.id) {
                        return true
                    }
                    return false
                })
                var where = '[' + primaryColumn.name + '] in (' + this.$state.params['ids'].join(',') + ')'
                if (fColumns.length > 0) {
                    var fColumn = fColumns[0]

                    if (!fColumn.where) {
                        fColumn.where = [where]
                    } else {
                        fColumn.where.push(where)
                    }
                } else {
                    var fColumn = new ColumnModel()
                    fColumn.name = primaryColumn.name
                    fColumn.id = primaryColumn.idDataType
                    fColumn.where = [where]
                }

                if (!this.shouldResetContextActionFilter) {

                    if (whereClause.where.length) {
                        whereClause.where = whereClause.where + " and "
                    }
                    whereClause.where = whereClause.where + where
                } else {
                    whereClause.where = where
                }
            }
        }

        var req = new GridRequestReferenceModel()
        req.idReferenceType = this.$scope.options.idReferenceType
        req.columns = columns
        req.pageSize = pageSize
        req.pageNumber = pageNumber
        req.where = whereClause.where
        return req
    }

    firstOnContentReady = true
    private onContentReady(e) {
        this.table = e.component
        this.tableElement = e.element

        if (this.firstOnContentReady) {
            this.firstOnContentReady = false
            if (this.isFilteredLocally) {
                this.customFilterColumns()
            }
            this.$timeout(() => {
                this.$scope.show = true
                this.initScrollEvents(e)
            })
        }

        if (e.element.find('.custom-grid-button').length == 0 && this.$scope.options.buttonsOptions.enabled) {
            this.addButtons('#gridContainer' + this.$scope.tableId)
        }
        if (this.$scope.options.onContentReady) {
            this.$scope.options.onContentReady(e)
        }

        if (this.$scope.options.showShortDetails) {
            var elementsToRemove = $(e.element).find('.dx-command-expand')
            elementsToRemove.closest('table').find('> colgroup > col:first-child').width(0)
            elementsToRemove.width(0)

            var visibleColumns: any[] = e.component._controllers.columns._visibleColumns[0]
            if (!angular.equals(visibleColumns, this.lastVisibleColumns)) {
                if (this.onChangeColumnsTimeout) clearTimeout(this.onChangeColumnsTimeout)
                this.onChangeColumnsTimeout = setTimeout(() => {
                    this.lastVisibleColumns = visibleColumns
                    e.component.collapseAll(-1)
                    e.component.deselectAll()
                }, 100)
            }
        }

        this.refreshFilters()

        this.onPageSizeChanged(e)
        this.onPageChanged(e)
        this.toggleMasterDetailColumn(e)

        // hack for dx-freespace-row
        this.$timeout(() => {
            var contentTable = this.tableElement.find('.dx-datagrid-rowsview .dx-datagrid-content > .dx-datagrid-table').first()
            var contentTableRows = contentTable.find('.dx-row')
            if (contentTableRows.length > 1) {
                var rowsHeight = 0
                for (var i = 0; i < contentTableRows.length; i++) {
                    var columnRow = angular.element(contentTableRows[i])
                    if (!columnRow.hasClass('dx-freespace-row')) {
                        rowsHeight += columnRow.outerHeight()
                    }
                }
                var parentHeight = contentTable.parent().parent().parent().parent().height()
                if (parentHeight - rowsHeight > 0) {
                    contentTableRows.last().height(parentHeight - rowsHeight).addClass('grid__freespace-hack')
                } else {
                    contentTableRows.last().height(0)
                }
            }
        })

        if (this.lastSelectedIds) {
            var ids: any[] = this.table.option('dataSource').items().map(item => item.id)
            var indexes: number[] = []
            this.lastSelectedIds.forEach(id => {
                var index = ids.indexOf(id)
                if (index > -1) {
                    indexes.push(index)
                }
            })
            this.table.selectRowsByIndexes(indexes)
            this.lastSelectedIds = null
        }

        this.updatePagerInfoText()
    }

    initScrollEvents(e) {
        var clicking = false;
        var posX = null, posY = null

        var rowsView = angular.element(e.element).find('.dx-datagrid-rowsview')

        rowsView.mousedown(e => {
            if (e.which === 2) {
                clicking = true;
                posX = e.screenX
                posY = e.screenY
            }
        });

        rowsView.mouseup(e => {
            clicking = false;
        })

        rowsView.mousemove(ev => {
            if (clicking == false) {
                return
            }

            var x = ev.screenX
            var y = ev.screenY

            var scrollable = e.component.getView('rowsView')._scrollable
            scrollable.scrollBy({ left: (x - posX) / 10, top: (y - posY) / 10 })
        });
    }

    addAdditionalTitleToLargeHeader(selector: any) {
        let elemToFind = angular.element(selector).find('.dx-datagrid-header-panel .dx-toolbar > .dx-toolbar-items-container > .dx-toolbar-before')
        elemToFind.prepend('<h4 class="__grid-additional-header-text">' + this.$scope.options.additionalTitle + '</h4>')
    }

    addButtons(selector) {
        var header = angular.element(selector).find('.dx-datagrid-header-panel .dx-toolbar > .dx-toolbar-items-container > .dx-toolbar-after')
        if (this.buttons && this.buttons.length > 0) {
            var buttonsString = '<div>'
            this.buttons.forEach(options => {
                if (options.name == "addButton"
                    || options.name == "selectionButton"
                    || options.name == "showPreviewButton"
                    || options.name == "editButton"
                    || options.name == "showDetailsButton"
                    || options.name == "actionFilters"
                    || options.name == "showMapButton"
                    || options.name == "refreshButton"
                    || options.name == 'depositoryContentEditButton'
                    || options.name == 'groupingLocationAssignLocationButton'
                    || options.name == "deleteRowsButton"
                    || options.name == 'problemConfirmationButton'
                    || options.name == 'planDeliveryButton'
                    || options.name == 'toggleDetailsRows'
                ) {
                    buttonsString += '<div ng-if="isLargeGridHeader' + (options.permissions ? ' && $root.hasPermissions(' + options.permissions + ')"' : '') + '" class="custom-grid-button dx-toolbar-button dx-toolbar-menu-container"><div class="dx-item-content dx-toolbar-item-content"><div id="' + options.name + this.$scope.tableId + '" dx-button="headerButtons[\'' + options.name + this.$scope.tableId + '\']"></div></div></div>'
                }
                if (options.name == "multiSelect") {
                    buttonsString += '<div ng-if="isLargeGridHeader" class="custom-grid-button dx-toolbar-button dx-toolbar-menu-container"><div class="dx-item-content dx-toolbar-item-content"><div id="' + options.name + this.$scope.tableId + '" dx-button="headerButtons[\'' + options.name + this.$scope.tableId + '\']" ng-class="{' + "'active-button'" + ': multiSelectEnabled}"></div></div></div>'
                }
            })

            _.forEach(this.customButtons, (buttonOptions: GridCustomButtonOptions, index: number) => {
                if (buttonOptions.location === GridCustomButtonLocation.Header) {
                    buttonsString += '<div ng-if="isLargeGridHeader" class="custom-grid-button dx-toolbar-button dx-toolbar-menu-container"><div class="dx-item-content dx-toolbar-item-content"><div dx-button="customHeaderButtons[\'' + index.toString() + this.$scope.tableId.toString() + '\']"></div></div></div>'
                }
            })

            buttonsString += '<div class="custom-grid-button dx-toolbar-button dx-toolbar-menu-container"><div class="dx-item-content dx-toolbar-item-content"><div id="popoverListButton' + this.$scope.tableId + '" dx-button="popoverListButtonOptions"></div></div></div>'
            buttonsString += '</div>'
            header.prepend(this.$compile(buttonsString)(this.$scope))
        }
        this.$scope.$broadcast('customButtonsGridAdded', header)
        if (this.$scope.isLargeGridHeader && this.$scope.options.additionalTitle != null && this.$scope.options.additionalTitle.length > 0) {
            this.addAdditionalTitleToLargeHeader(selector)
        }
    }

    isDashboardButtonVisible(button) {
        if (this.$scope.options.buttonsOptions.dashboardSettings && this.$scope.options.buttonsOptions.dashboardSettings.length > 0) {
            return this.$scope.options.buttonsOptions.dashboardSettings.some(opt => {
                return opt.option === button && opt.visible
            })
        } else {
            return false
        }
    }

    isDashboardButtonSettingsPresent(button) {
        if (this.$scope.options.buttonsOptions.dashboardSettings && this.$scope.options.buttonsOptions.dashboardSettings.length > 0) {
            return this.$scope.options.buttonsOptions.dashboardSettings.some(opt => {
                return opt.option === button
            })
        } else {
            return false
        }
    }

    private onToggleDetailsRowsClick = (): void => {
        const rows: DevExpress.ui.dxDataGridRowObject[] = this.table.getVisibleRows()

        if (rows.length > 0) {
            const isAnyRowExpanded: boolean = rows.some((row: DevExpress.ui.dxDataGridRowObject) => row.isExpanded === true)

            if (isAnyRowExpanded) {
                this.table.collapseAll(-1)
            } else {
                this.table.expandAll(-1)
            }

            if (_.isFunction(this.$scope.options.buttonsOptions.onToggleDetailsRows)) {
                this.$scope.options.buttonsOptions.onToggleDetailsRows(!isAnyRowExpanded)
            }
        }
        $('.dx-button').blur()
    }


    private getActiveView(): JQueryPromise<OpView> {
        const idReferenceType: number = this.$scope.options.referenceId

        if (idReferenceType != null) {
            return this.userSession
                .getDataProvider().View
                .getActiveView(idReferenceType)
                .then((view: OpView) => {
                    if (view == null) {
                        console.info(this.LOG_STRING, 'Unable to find the view for the given referenceId, proceeding without it.')
                    }

                    return view
                })
                .fail((error: any) => {
                    console.warn(this.LOG_STRING, 'Unable to load the view for the given referenceId, proceeding without it.', error)
                })
        }

        console.info(this.LOG_STRING, 'No reference type given, proceeding without a view.')

        return null
    }

    private getPageItems(): JQueryPromise<any> {
        const deferred = $.Deferred();
        this.allowedPageSizes = ConfigHelper.getValue(Enums.SimaxConfigSection.Grid, ConfigHelper.Key.PageSizes)
        this.defaultPageSize = ConfigHelper.getValue(Enums.SimaxConfigSection.Grid, ConfigHelper.Key.DefaultPageSize)
        return this.userSession
            .getDataProvider()
            .Operator
            .getOperatorSettings(this.userSession.getIdLoggedOperator(), [Enums.SimaxOperatorSetting.PageItemsNumber])
            .then((settings: any) => {
                if (
                    settings != null &&
                    settings.length > 0 &&
                    settings[0] != null &&
                    settings[0].length > 0
                ) {
                    this.allowedPageSizes = settings[0]
                    this.defaultPageSize = this.allowedPageSizes[0]
                }
            })
            .fail(() => {
                return deferred.reject('Unable to load custom page sizes.')
            })
    }
}